export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Escrime XII - Issue 121",
  "shortTitle": "",
  "description": "",
  "width": 1195,
  "height": 896,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://escrime-xxi.fie.org/121/en/"
  },
  {
    code: "FR",
    text: "French",
    href: "https://escrime-xxi.fie.org/121/fr/"
  },
  {
    code: "ES",
    text: "Spanish",
    href: "https://escrime-xxi.fie.org/121/es/"
  }],
  "basePath": "/121/en",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://escrime-xxi.fie.org/121/en/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/121/en/static/_content/en-121.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": true,
    "guideEnabled": false,
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale197 1-title" style="top:84px;left:52px;" src="/121/en/static/_content/1-title-1.png">
      <img class="abs halfScale197 1-title" style="top:215px;left:52px;" src="/121/en/static/_content/1-title-2.png">
      <img class="abs halfScale197 1-title" style="top:1px;left:294px;" src="/121/en/static/_content/1-numerals-1.png">
      <img class="abs halfScale197 1-title" style="top:86px;left:840px;" src="/121/en/static/_content/1-ed-1.png">
      <img class="abs halfScale197 1-title" style="top:85px;left:974px;" src="/121/en/static/_content/logo.png">
      <img class="abs halfScale197 1-title" style="top:287px;left:55px;" src="/121/en/static/_content/1-sub-1.png">
      <img class="abs halfScale197 1-title" style="top:288px;left:922px;" src="/121/en/static/_content/1-sub-2.png">
      <img class="abs halfScale197 1-title" style="top:347px;left:915px;" src="/121/en/static/_content/1-sub-3.png">
    `,
    "mobileHtml": `
        <img src="/121/en/static/_mobile/1-mobile-1.jpg">
      `,
    "script": `
      function onPageEnter() {
        pg1Anim = new TimelineMax();
        pg1Anim
          .staggerFromTo(cOf("1-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
      }
    
      function onPageLeave() {
        pg1Anim.stop();
      }
    `,
    "searchText": "N˚121 DIGITAL MAGAZINE  FÉDÉRATION INTERNATIONALE D’ESCRIME  CAIRO 2022 FENCING WORLD CHAMPIONSHIPS  WORLD CUP GRAND PRIX  Use your keyboard keys, or swipe to navigate left and right through the magazine"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale197 pointer howto-desktop" style="top:97px;left:709px;" onclick="switchPopHowto(true)"
        src="/121/en/static/_content/2-desktop-btn.png">
      <img class="abs halfScale pointer howto-ipad" style="top:97px;left:867px;opacity:0" onclick="switchPopHowto(false)"
        src="/121/en/static/_content/2-ipad-btn.png">
      <img class="abs halfScale197 2-demo howto-desktop" style="top:201px;left:66px;" src="/121/en/static/_content/2-desktop.png">
      <img class="abs halfScale197 2-demo howto-ipad" style="top:194px;left:66px; opacity:0" src="/121/en/static/_content/2-ipad.png">
      <img class="abs halfScaleC197 2-img" style="top:442px;left:-244px;" src="/121/en/static/_content/2-img-1.png">
      <img class="abs halfScaleC197 2-img" style="top:444px;left:-162px;" src="/121/en/static/_content/2-img-2.png">
      <img class="abs halfScaleC197 2-img" style="top:443px;left:169px;" src="/121/en/static/_content/2-img-3.png">
      <img class="abs halfScaleC197 2-img" style="top:443px;left:496px;" src="/121/en/static/_content/2-img-4.png">

      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg2Anim = new TimelineMax();
        pg2Anim
          .staggerFromTo(cOf("2-img"), 0.6, {scale: 0}, {scale:0.197, ease: Back.easeOut.config(1.7)}, 0.3, 1)
      }

      function switchPopHowto(bool){
        if(bool){
          TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
            cOf("howto-ipad")[0].style.opacity = 0;
            cOf("howto-ipad")[1].style.display = "none";
          }});
          cOf("howto-desktop")[0].style.opacity = 1;
          cOf("howto-desktop")[1].style.display = "block";
          TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
        }else{
          cOf("howto-ipad")[0].style.opacity = 1;
          cOf("howto-ipad")[1].style.display = "block";
          TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
          TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
            cOf("howto-desktop")[0].style.opacity = 0;
            cOf("howto-desktop")[1].style.display = "none";
          }});
        }
      }

      function onPageLeave() {
        pg2Anim.stop();
        resetNumbers("2-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "HOW TO USE  Click to change view  HOW TO USE Escrime XXI The Fencing Magazine uses the latest digital technology - here are some of the exciting features to enjoy.  DESKTOP  IPAD  SP ORT  MEN'S AND WOMEN'S EPEE GRAND PRIX IN BUDAPEST BUDAPEST, HUNGARY 4–6 MARCH 2022  BROWSING Use the arrows on your keypad to navigate horizontally through the magazine  Navigation To view the magazine, use the arrows on your keypad to travel left and right through the publication.  BROWSER For the best results, we recommend using Safari or Google Chrome  EXPLORE  e.. Hotspots insid  .  1 2 3 POP UPS  PLAY BUTTON  SOCIAL MEDIA  NUMBERS  Press to reveal, and hide, nuggets of information.  This magazine features great video. Pushing this will launch one.  Press the social media icons found throughout the magazine  Push the buttons to reveal more exciting content.  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": `
      <a href="https://www.absolutefencinggear.com/" target="_blank" class="contentLinkNone" style="    top: 740px; left: 445px; width: 710px; height: 60px;"></a>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
      <a href="https://www.absolutefencinggear.com/" target="_blank">
        <img src="/121/en/static/_mobile/3-mobile-1.jpg">
      </a>
    `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale197 4-title" style="top:63px;left:64px;" src="/121/en/static/_content/4-title-1.png">

      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC abs halfpulse197 animatedpulse" style="top: -2px; left:604px;" src="/121/en/static/_content/fb-navy.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC abs halfpulse197 animatedpulse" style="top: 37px; left:604px;" src="/121/en/static/_content/tw-navy.png">
      </a>
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
      <img id="4-next" class="halfScale111 pointer" style="top:733px;right:-782px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-blue.png">

        <img class="cont-item cont-item-1-btn halfScale" style="top:255px; left: 448px;opacity:0;"
          src="/121/en/static/_content/4-popup-1.png">
        <img class="cont-item cont-item-2-btn halfScale" style="top:263px;left:448px;opacity:0"
          src="/121/en/static/_content/4-popup-2-1.png">
        <img class="cont-item cont-item-3-btn halfScale" style="top:263px;left:448px;opacity:0"
          src="/121/en/static/_content/4-popup-2-2.png">
        <img class="cont-item cont-item-4-btn halfScale" style="top:263px;left:448px;opacity:0"
          src="/121/en/static/_content/4-popup-2-3.png">
        <img class="cont-item cont-item-5-btn halfScale" style="top:207px;left:448px;opacity:0"
          src="/121/en/static/_content/4-popup-3.png">
        <img class="cont-item cont-item-6-btn halfScale" style="top:274px;left:448px;opacity:0"
          src="/121/en/static/_content/4-popup-4.png">
        <img class="cont-item cont-item-7-btn halfScale" style="top:255px;left:448px;opacity:0"
          src="/121/en/static/_content/4-popup-5.png">
        
        <div class="addContentLink" onclick="contentsBub(1);" style="top: 277px; left: 63px; width: 389px; height: 53px;"></div>
        <div class="addContentLink" onclick="contentsBub(2);" style="top: 349px; left: 63px; width: 389px; height: 53px;"></div>
        <div class="contentLinkNone 2-click" onclick="contentsBub(2);"
        style="top: 727px; left: 507px; width: 169px; height: 54px;display:none"></div>
        <div class="contentLinkNone 3-click" onclick="contentsBub(2);"
          style="top: 727px; left: 507px; width: 169px; height: 54px;display:none"></div>
        <div class="contentLinkNone 4-click" onclick="contentsBub(2);"
          style="top: 727px; left: 507px; width: 169px; height: 54px;display:none"></div>
        <div class="contentLinkNone 2-click" onclick="contentsBub(3);"
          style="top: 727px; left: 697px; width: 169px; height: 54px;display:none"></div>
        <div class="contentLinkNone 3-click" onclick="contentsBub(3);"
          style="top: 727px; left: 697px; width: 169px; height: 54px;display:none"></div>
        <div class="contentLinkNone 4-click" onclick="contentsBub(3);"
          style="top: 727px; left: 697px; width: 169px; height: 54px;display:none"></div>
        <div class="contentLinkNone 2-click" onclick="contentsBub(4);"
          style="top: 727px; left: 886px; width: 169px; height: 54px;display:none"></div>
        <div class="contentLinkNone 3-click" onclick="contentsBub(4);"
          style="top: 727px; left: 886px; width: 169px; height: 54px;display:none"></div>
        <div class="contentLinkNone 4-click" onclick="contentsBub(4);"
          style="top: 727px; left: 886px; width: 169px; height: 54px;display:none"></div>
        <div class="addContentLink" onclick="contentsBub(5);" style="top: 420px; left: 63px; width: 389px; height: 53px;"></div>
        <div class="addContentLink" onclick="contentsBub(6);" style="top: 493px; left: 63px; width: 389px; height: 53px;"></div>
        <div class="addContentLink" onclick="contentsBub(7);" style="top: 565px; left: 63px; width: 389px; height: 53px;"></div>
        
        <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)"
          style="top: 277px; left: 452px; width: 499px; height: 53px;display:none;"></div>

        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)"
          style="top: 275px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(16)"
          style="top: 347px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(18)"
          style="top: 419px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(21)"
          style="top: 492px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(25)"
          style="top: 564px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(27)"
          style="top: 636px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(29)"
          style="top: 275px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(31)"
          style="top: 347px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(34)"
          style="top: 419px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(37)"
          style="top: 492px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(41)"
          style="top: 564px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(43)"
          style="top: 636px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(45)"
          style="top: 347px; left: 442px; width: 605px; height: 50px;display:none;"></div>
        
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(48);setTimeout(function(){showOverlay('48-popup-1'), 1000})"" style="top: 275px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(48);setTimeout(function(){showOverlay('48-popup-2'), 1000})"" style="top: 347px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(48);setTimeout(function(){showOverlay('48-popup-3'), 1000})"" style="top: 419px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(48);setTimeout(function(){showOverlay('48-popup-4'), 1000})"" style="top: 492px; left: 452px; width: 605px; height: 53px;display:none;"></div>

        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(50)"
          style="top: 275px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(53)"
          style="top: 347px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(60)"
          style="top: 419px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(67)"
          style="top: 492px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(74)"
          style="top: 564px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        
        <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(82);setTimeout(function(){pg82Toggle('82-1', '82-cta-1'), 1000})"
          style="top: 492px; left: 452px; width: 605px; height: 53px;display:none;"></div>
        <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(82);setTimeout(function(){pg82Toggle('82-2', '82-cta-2'), 1000})"
          style="top: 564px; left: 452px; width: 605px; height: 53px;display:none;"></div>
    `,
    "script": `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        pg4Anim
          .fromTo(cOf("4-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }

      function contentsBub(index){
        console.log(index)
        for(var i=0; i <= 9; i++){
          if(i == index){
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
              c.style.display = "";
            },0);
            [].slice.call(cOf(i+"-click")).reduce(function(p,c){
              c.style.display = "";
            },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0, {opacity:1, onComplete:function(){
              
              cOf("cont-item-"+index+"-link")[0].style.display = ""
              if(cOf("cont-item-"+index+"-link")[1]){
                cOf("cont-item-"+index+"-link")[1].style.display = "" 
              }
            }});
          }else{
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                c.style.display = "none";
              },0);
            [].slice.call(cOf(i+"-click")).reduce(function(p,c){
                c.style.display = "none";
              },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0, {opacity:0});
          }
        }
      }

      function onPageLeave() {
        pg4Anim.stop();
        resetNumbers("4-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "C ONTENTS  THIS ISSUE  Welcome to the latest edition of Escrime XXI, packed with the best fencing images, video and features and showcased in a striking new look.  WWW.FIE.ORG  EDITORIAL  SPORT  Tap buttons to reveal content  FIE NEWS N˚121  CONFEDERATION NEWS  DIGITAL MAGAZINE  FÉDÉRATION INTERNATIONALE D’ESCRIME  OBITUARIES  CAIRO 2022 FENCING WORLD CHAMPIONSHIPS  WORLD CUP GRAND PRIX  Use your keyboard keys, or swipe to navigate left and right through the magazine  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": `
      <a href="mailto:info@fie.ch">
        <div class="contentLink" style="bottom: 170px; right: 536px; width: 124px; height: 21px;"></div>
      </a>
      <a href="http://www.touchline.com" target="_blank">
        <div class="contentLink" style="    bottom: 308px; right: 243px; width: 234px; height: 21px;"></div>
      </a>
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLink" style="bottom: 149px; right: 577px; width: 82px; height: 21px;"></div>
      </a>

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC197 pointer halfpulse197 animatedpulse" style="top:718px;left:-29px"
          src="/121/en/static/_content/tw-white.png">
      </a>

      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC197 pointer halfpulse197 animatedpulse" style="top:718px;left:24px"
          src="/121/en/static/_content/fb-white.png">
      </a>

      <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
        <img class="halfScaleC197 pointer halfpulse197 animatedpulse" style="top:718px;left:77px"
          src="/121/en/static/_content/yt-white.png">
      </a>

      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 61px; width: 90px; height: 17px;"></div>
      </a>

      <img id="5-next" class="halfScale111 pointer" style="top:665px;right:-765px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-blue.png">
    `,
    "script": `
      function onPageEnter() {
        pg5Anim = new TimelineMax();
        pg5Anim
          .fromTo(idOf("5-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }

      function onPageLeave() {
        pg5Anim.stop();
        resetNumbers("5-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "mobileHtml": `
        <p>
        <b>Interim President</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>
        <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>
        <p>
        <b>Vice Presidents</b>:<br>
        Erika Aze (LAT)<br>
        Ana Irene Delgado Guerra (PAN)<br>
        Abdelmoneim Elhamy El Husseiny (EGY)<br></p>
        <p>
        <b>Members</b>:<br>
        Rusni Abu Hassan (MAS)<br>
        Donald Anthony Jr. (USA)<br>
        Paolo Azzi (ITA)<br>
        Bruno Gares (FRA)<br>
        Vadym Guttsait (UKR)<br>
        Velichka Hristeva (BUL)<br>
        Yuki Ota (JPN)<br>
        Novak Perovic (RSA)<br>
        Oleg Peskov (KAZ)<br>
        Haibin Wang (CHN)<br>
        Ruben Limardo (VEN) President of the FIE Athletes' Commission <br></p>

        <p>
          <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>
          <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>
          <b>President, Asian Fencing Confederation</b>: <br>HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE)<br>
          <b>Secretary-General, European Fencing Confederation:</b> <br>Giorgio Scarso (ITA)<br>
          <b>President, Oceanian Fencing Confederation:</b><br> Helen Smith (M.H.) (AUS)<br>
        </p>
        
        <h2>FIE Head Office</h2>
        <p>
        <b>Chief Executive Officer</b><br>
        Nathalie Rodriguez M.-H.
        </p>

        <h2>Administration</h2>
        <p>
        <b>Administration Director</b>:<br> Elena Murdaca <br>
        <b>Accounting Manager</b>:<br> Sandra Baroni <br>
        <b>Administrative Assistant</b>:<br> Ylenia Murdaca <br>
        <b>Project Manager</b>:<br> Ekaterina Mashina<br>
        </p>

        <h2>Sport</h2>
        <p>
        <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova<br>
        <b>Head of Operations</b>:<br>Elena Huot<br>
        </p>
        <h2>Communication, Marketing, TV</h2>
        <p>
        <b>Digital Communications Manager</b>:<br> Maria Ntanou<br>
        <b>Head of FIE TV Production</b>:<br> Barna Heder<br>
        <b>Press Officer</b>:<br> Serge Timacheff<br>
        <b>Photographer</b>:<br> Augusto Bizzi<br>
        </p>

        <h2>Design</h2>
        <p>
        <b>Touchline </b><br>
        (<a href="http://www.touchline.com" target="blank">www.touchline.com</a>)
        </p>
      `,
    "searchText": "LIST OF C OME X  FIE HEAD OFFICE  Interim President: Emmanuel Katsiadakis (M.H.) (GRE) Secretary Treasurer: Ferial Nadira Salhi (ALG)  Chief Executive Officer Nathalie Rodriguez M.-H.  Vice Presidents: Erika Aze (LAT) Ana Irene Delgado Guerra (PAN) Abdelmoneim Elhamy El Husseiny (EGY) Members: Rusni Abu Hassan (MAS) Donald Anthony Jr. (USA) Paolo Azzi (ITA) Bruno Gares (FRA) Vadym Guttsait (UKR) Velichka Hristeva (BUL) Yuki Ota (JPN) Novak Perovic (RSA) Oleg Peskov (KAZ) Haibin Wang (CHN) Aldo Montano President of the FIE Athletes’ Commission (ITA) President, African Fencing Confederation: Mbagnick Ndiaye (SEN) President, Pan-American Fencing Confederation: Vitaly Logvin (MEX) President, Asian Fencing Confederation: HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE) Secretary-General, European Fencing Confederation: Jacek Slupski (POL) President, Oceanian Fencing Confederation: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head Office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Administration  Administration Director: Elena Murdaca Accounting Manager: Sandra Baroni Administrative Assistant: Ylenia Murdaca Project Manager: Ekaterina Mashina Sport  Sport Technology and Administration Manager: Natalia Bodrova  Head of Operations: Elena Huot Communication, Marketing, TV  Digital Communications Manager: Maria Ntanou  Head of FIE TV Production: Barna Heder  Press Officer: Serge Timacheff Photographer: Augusto Bizzi Design Touchline (www.touchline.com)  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": `
      <img id="6-img" class="halfScale197 6-text-1 6-text" style="top:240px;left:337px"
        src="/121/en/static/_content/6-img-1.png">
      <img id="6-title" class="halfScale197 6-title 6-text-1 6-text" style="top:593px;left:157px"
        src="/121/en/static/_content/6-title-1.png">
      <img id="6-text-1" class="halfScale197 6-text-1 6-text" style="top:242px;left:612px"
        src="/121/en/static/_content/6-text-1.png">
      <img id="6-text-2" class="halfScale 6-text-2 6-text" style="top:241px;left:155px; opacity:0;"
        src="/121/en/static/_content/6-text-2.png">
      
      <img id="6-cta-1" class="halfScale197 pointer 6-btn" style="top: 660px; left: 612px;"
        onclick="toggleText6(false);" src="/121/en/static/_content/6-btn-1.png">
      <img id="6-cta-2" class="halfScale pointer 6-btn" style="top: 660px; left: 829px;opacity:0"
        onclick="toggleText6(true);" src="/121/en/static/_content/6-btn-2.png">

      <img id="6-next" class="halfScale197 pointer" style="top:731px;right:-379px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-navy.png">

      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "mobileHtml": `
      <h2>THE WORLD CHAMPIONSHIPS SHINE IN CAIRO</h2>
      <img src="/121/en/static/_mobile/6-mobile-1.png">
      <p>Dear Friends,</p>
      <p>Throughout 2022, we have seen fencing continue to grow and capture the hearts of fans 
      and participants around the world. Indeed, we find ourselves in the best position since 
      before the pandemic, with our sporting calendar finally returning to full strength and giving many the chance to be on the piste and enjoy international fencing. </p>
      <p>This includes the exciting reintroduction of zonal competitions in June with championships across Pan America, Asia, Africa and Europe once again proving resounding accomplishments.</p>
      <p>The successful completion of the 2022 Cairo Senior Fencing World Championships in July welcomed an impressive 902 fencers from 102 countries. We thank the Egyptian Fencing Federation for hosting the event, which followed the fantastic 2021 Junior and Cadet Fencing World Championships that also took place in Cairo. The World Championships will travel to Milan, Italy in 2023 and we are sure it will be a wonderful experience for all.</p>
      <p>The World Championships also featured the election of six new members to the Athletes’ Commission, and we look forward to working with them in the future to ensure fencers are properly represented and have a strong voice in our sport.</p>
      <p>Cairo also demonstrated our continued focus on educational programmes to support athletes, coaches and as many people as possible in a positive way. FIE-hosted anti-doping webinars before the World Championships, and had educational stands set up at the World Championships, crucial to our efforts to maintain a clean and safe sport and support our athletes in the best ways possible.</p>
      <p>Through these programmes and competitions, we must continue to work together to make fencing an exciting, engaging and excellent experience for all involved and raise it to new heights. We thank you for your steadfast support and wish you a successful and memorable competitive season.</p>
      <p>Emmanuel Katsiadakis<br>
      Interim President</p>
    `,
    "script": `
      function onPageEnter() {
        pg6Anim = new TimelineMax();
        pg6Anim
          .fromTo(cOf("6-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(idOf("6-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }

      function toggleText6(bool){
        var text1 = idOf("6-text-1");
        var text2 = idOf("6-text-2");
        
        if(!bool && text1.style.opacity == "0"){
          pg6Anim.play();
          TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:0}, {opacity:1});
        }else if(bool && text2.style.opacity == "0"){
          pg6Anim.pause();
          TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:1}, {opacity:0});
        }
      }

      function onPageLeave() {
        pg6Anim.stop();
        resetNumbers("6-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FORE WORD  Dear Friends, Throughout 2022, we have seen fencing continue to grow and capture the hearts of fans and participants around the world. Indeed, we find ourselves in the best position since before the pandemic, with our sporting calendar finally returning to full strength and giving many the chance to be on the piste and enjoy international fencing.  THE WORLD CHAMPIONSHIPS SHINE IN CAIRO  This includes the exciting reintroduction of zonal competitions in June with championships across Pan America, Asia, Africa and Europe once again proving resounding accomplishments.  PAGE 1  PAGE 2  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": `
      <a href="https://shop.pbtfencing.com/" target="_blank">
        <div class="contentLinkNone" style="bottom: 21px; right: 739px; width: 193px; height: 38px;"></div>
      </a>
      <a href="mailto:sales@pbtfencing.com" target="_blank">
        <div class="contentLinkNone" style="bottom:21px;right:516px;width:205px;height:38px;"></div>
      </a>
      <a href="https://www.instagram.com/pbt_fencing" target="_blank">
        <div class="contentLinkNone" style="bottom: 21px; right: 269px; width: 236px; height: 38px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
      <a href="https://shop.pbtfencing.com/" target="_blank">
        <img src="/121/en/static/_mobile/7-mobile-1.jpg">
      </a>
    `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale197 8-title" style="top:174px;left:66px;" src="/121/en/static/_content/8-title-1.png">
      <img class="abs halfScale197 8-sub" style="top:359px;left:263px;" src="/121/en/static/_content/8-sub-1.png">
      <img class="abs halfScale197 8-line" style="top:352px;left:238px;" src="/121/en/static/_content/8-line-1.png">
      <img id="8-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg8Anim = new TimelineMax();
        pg8Anim
          .fromTo(cOf("8-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("8-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("8-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("8-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }

      function onPageLeave() {
        pg8Anim.stop();
        resetNumbers("8-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  A GRAND SUCCESS CAIRO 2022 FENCING WORLD CHAMPIONSHIPS FINISH CAIRO, EGYPT 15-23 JULY",
    "mobileHtml":`
      <h2>A Grand Success Cairo 2022 Fencing World Championships Finish</h2>
      <img src="/121/en/static/_mobile/8-mobile-1.png">
      <p><strong>Cairo, Egypt 15-23 July</strong></p>
      <p>The Cairo 2022 Fencing World Championships finished successfully after completing three days of preliminary and six days of finals competition in 12 individual and team events for men and women in epee, foil and sabre. </p>
      <p>The Championships took place at the Indoor Halls Complex of the Cairo International Stadium, Nasr City.</p>
      <p>Overall, 102 countries and 902 fencers participated, including 492 men and 410 women.</p>
      <p>This was the second time the Senior Fencing World Championships have taken place in Cairo, the first being held in 1949. In 2021, the Egyptian fencing federation organised the Junior and Cadet Fencing World Championships, which were also hosted at the Cairo International Stadium Indoor Halls Complex.</p>
      <p>On July 18, the first evening of finals competition, an opening ceremony was held, and FIE Interim President Emmanuel Katsiadakis welcomed guest dignitaries including Egyptian Minister of Youth and Sports, His Excellency Dr. Ashraf Sobhy; President of the Egyptian Olympic Committee, Engineer Hesham Hatab; President of the Egyptian Fencing Federation, Mr. Abdelmoneim El Husseiny; and President of the International Handball Association, Dr. Hassan Moustafa.</p>
      <p>At the official closing ceremony on July 23, Mr. Katsiadakis received the FIE flag from President El Husseiny, passing it to Italian Fencing Federation President Paolo Azzi for the 2023 Fencing World Championships being held next July in Milan.</p>
      <p>“The Cairo World Championships have been a grand success”, stated Mr. Katsiadakis. “We deeply appreciate the hard work and tremendous efforts by the Egyptian organisers, staff and volunteers. With its friendly hosts, excellent accommodations and historic sites, Cairo has proven itself as an ideal destination for the World Championships. We congratulate our new world champions and wish everyone a safe journey home as we anticipate the next year of fencing competition.”</p>
      <p>France won the medal ranking, with four golds, two silvers and two bronzes for a total of eight overall, followed by Korea (three golds) and Italy (two golds, four silvers and two bronzes).</p>
      <p>Listed below are the medallists from each event:</p>

      <h4>July 18</h4>
      <p><strong>Men’s Individual Sabre</strong></p>
      <p>
      1. Aron Szilagyi (HUN, gold)<br>
      2. Maxime Pianfetti (FRA, silver)<br>
      3. Sandro Bazadze (GEO, bronze)<br>
      3. Iulian Teodosiu (ROU, bronze)
      </p>

      <p><strong>Women’s Individual Epee</strong></p>
      <p>
      1. Sera Song (KOR, gold)<br>
      2. Alexandra Ndolo (GER, silver)<br>
      3. Rossella Fiamingo (ITA, bronze)<br>
      3. Man Wai Vivian Kong (HKG, bronze)
      </p>

      <h4>July 19</h4>
      <p><strong>Men’s Individual Epee</strong></p>
      <p>
      1. Romain Cannone (FRA, gold)<br>
      2. Kazuyasu Minobe (JPN, silver)<br>
      3. Neisser Loyola (BEL, bronze)<br>
      3. Igor Reizlin (UKR, bronze)
      </p>

      <p><strong>Women’s Individual Foil </strong></p>
      <p>
      1. Ysaora Thibus (FRA, gold)<br>
      2. Arianna Errigo (ITA, silver)<br>
      3. Maria Boldor (ROU, bronze)<br>
      3. Lee Kiefer (USA, bronze)
      </p>

      <h4>July 20</h4>
      <p><strong>Men’s Individual Foil</strong></p>
      <p>
      1. Enzo Lefort (FRA, gold)<br>
      2. Tommaso Marini (ITA, silver)<br>
      3. Ka Long Cheung (HKG, bronze)<br>
      3. Nick Itkin (USA, bronze)
      </p>

      <p><strong>Women’s Individual Sabre </strong></p>
      <p>
      1. Misaki Emura (JPN, gold)<br>
      2. Anna Bashta (AZE, silver)<br>
      3. Despina Georgiadou (GRE, bronze)<br>
      3. Araceli Navarro (ESP, bronze)
      </p>

      <h4>July 21</h4>
      <p><strong>Men’s Team Sabre </strong></p>
      <p>
      1. Korea (gold)<br>
      2. Hungary (silver)<br>
      3. Italy (bronze)
      </p>

      <p><strong>Women’s Team Epee </strong></p>
      <p>
      1. Korea (gold)<br>
      2. Italy (silver)<br>
      3. Poland (bronze)
      </p>

      <h4>July 22</h4>
      <p><strong>Men’s Team Epee </strong></p>
      <p>
      1. France (gold)<br>
      2. Italy (silver)<br>
      3. Japan (bronze)
      </p>

      <p><strong>Women’s Team Foil </strong></p>
      <p>
      1. Italy (gold)<br>
      2. USA (silver)<br>
      3. France (bronze)
      </p>

      <h4>July 23</h4>
      <p><strong>Men’s Team Foil </strong></p>
      <p>
      1. Italy (gold)<br>
      2. USA (silver)<br>
      3. France (bronze)
      </p>

      <p><strong>Women’s Team Sabre</strong></p>
      <p>
      1. Hungary (gold)<br>
      2. France (silver)<br>
      3. Japan (bronze)
      </p>
      `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
      
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>

      <img id="9-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">

      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg9Anim = new TimelineMax();
        pg9Anim
          .fromTo(idOf("9-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }

      function onPageLeave() {
        pg9Anim.stop();
        resetNumbers("9-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "2022 WORLD CHAMPIONSHIPS CAIRO, EGYPT 2 OF 7  The Cairo 2022 Fencing World Championships finished successfully after completing three days of preliminary and six days of finals competition in 12 individual and team events for men and women in epee, foil and sabre. The Championships took place at the Indoor Halls Complex of the Cairo International Stadium, Nasr City. Overall, 102 countries and 902 fencers participated, including 492 men and 410 women. This was the second time the Senior Fencing World Championships have taken place in Cairo, the first being held in 1949. In 2021, the Egyptian fencing federation organised the Junior and Cadet Fencing World Championships, which were also hosted at the Cairo International Stadium Indoor Halls Complex. On July 18, the first evening of finals competition, an opening ceremony was held, and FIE"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="10-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg10Anim = new TimelineMax();
        pg10Anim
          .fromTo(idOf("10-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg10Anim.stop();
        resetNumbers("10-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "2022 WORLD CHAMPIONSHIPS CAIRO, EGYPT 3 OF 7  Interim President Emmanuel Katsiadakis welcomed guest dignitaries including Egyptian Minister of Youth and Sports, His Excellency Dr. Ashraf Sobhy; President of the Egyptian Olympic Committee, Engineer Hesham Hatab; President of the Egyptian Fencing Federation, Mr. Abdelmoneim El Husseiny; and President of the International Handball Association, Dr. Hassan Moustafa. At the official closing ceremony on July 23, Mr. Katsiadakis received the FIE flag from President El Husseiny, passing it to Italian Fencing Federation President Paolo Azzi for"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="11-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg11Anim = new TimelineMax();
        pg11Anim
          .fromTo(idOf("11-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg11Anim.stop();
        resetNumbers("11-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "2022 WORLD CHAMPIONSHIPS CAIRO, EGYPT 4 OF 7  the 2023 Fencing World Championships being held next July in Milan. “The Cairo World Championships have been a grand success”, stated Mr. Katsiadakis. “We deeply appreciate the hard work and tremendous efforts by the Egyptian organisers, staff and volunteers. With its friendly hosts, excellent accommodations and historic sites, Cairo has proven itself as an ideal destination for the World Championships. We congratulate our new world champions and wish everyone a safe journey home as we anticipate the next year of fencing competition.”"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px" src="/121/en/static/_content/fb-red.png">
      </a>

      <a href="https://youtu.be/NOjV7D-2m7s" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:701px;left:437px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/QRX4bVMJutY" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:558px;left:869px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/nmd8jxwI8R4" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:725px;left:841px" src="/121/en/static/_content/play-red.png">
      </a>

      <img id="12-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg12Anim = new TimelineMax();
        pg12Anim
          .fromTo(idOf("12-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg12Anim.stop();
        resetNumbers("13-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "2022 WORLD CHAMPIONSHIPS CAIRO, EGYPT 5 OF 7  France won the medal ranking, with four golds, two silvers and two bronzes for a total of eight overall, followed by Korea (three golds) and Italy (two golds, four silvers and two bronzes). Listed below are the medallists from each event: July 18 Men’s Individual Sabre 1. Aron Szilagyi (HUN, gold) 2. Maxime Pianfetti (FRA, silver)  3. Sandro Bazadze (GEO, bronze) 3. Iulian Teodosiu (ROU, bronze) Women’s Individual Epee 1. Sera Song (KOR, gold) 2. Alexandra Ndolo (GER, silver) 3. Rossella Fiamingo (ITA, bronze) 3. Man Wai Vivian Kong (HKG, bronze) July 19 Men’s Individual Epee 1. Romain Cannone (FRA, gold)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>

      <a href="https://youtu.be/0ifZkM0FOtc" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:534px;left:444px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/r47PC0jimJA" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:701px;left:415px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/9J03U9Jm7xM" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:509px;left:891px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/DheAEpzzfIM" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:677px;left:825px" src="/121/en/static/_content/play-red.png">
      </a>
    
      <img id="13-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg13Anim = new TimelineMax();
        pg13Anim
          .fromTo(idOf("13-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg13Anim.stop();
        resetNumbers("13-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "2022 WORLD CHAMPIONSHIPS CAIRO, EGYPT 6 OF 7  2. Kazuyasu Minobe (JPN, silver) 3. Neisser Loyola (BEL, bronze) 3. Igor Reizlin (UKR, bronze) Women’s Individual Foil 1. Ysaora Thibus (FRA, gold) 2. Arianna Errigo (ITA, silver) 3. Maria Boldor (ROU, bronze) 3. Lee Kiefer (USA, bronze) July 20 Men’s Individual Foil 1. Enzo Lefort (FRA, gold) 2. Tommaso Marini (ITA, silver)  3. Ka Long Cheung (HKG, bronze) 3. Nick Itkin (USA, bronze) Women’s Individual Sabre 1. Misaki Emura (JPN, gold) 2. Anna Bashta (AZE, silver) 3. Despina Georgiadou (GRE, bronze) 3. Araceli Navarro (ESP, bronze) July 21 Men’s Team Sabre 1. Korea (gold) 2. Hungary (silver) 3. Italy (bronze)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>

      <a href="https://youtu.be/73ignB3k10Q" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:127px;left:417px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/fC5K5q_q-Z8" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:270px;left:389px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/TjDgZ4o80J0" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:390px;left:405px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/RUGhd4Z6mG0" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:534px;left:378px" src="/121/en/static/_content/play-red.png">
      </a>
      <a href="https://youtu.be/ZPsHI8Kklrs" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:653px;left:425px" src="/121/en/static/_content/play-red.png">
      </a>
    
      <img id="14-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
        
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>

      <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:558px;left:-25px" onclick="showOverlay('14-popup-1')"
        src="/121/en/static/_content/fencer-red.png">

      <div id="14-popup-1" class="standardTransition contentOverlay hidden noclick">
        <img class="halfScale" src="/121/en/static/_content/14-popup-1.png" alt="">
        <div class="contentLink" style="top: 79px; left: 1065px; width: 35px; height: 35px;"
          onclick="hideOverlay('14-popup-1');"></div>
      </div>
    `,
    "script": `
      function onPageEnter() {
        pg14Anim = new TimelineMax();
        pg14Anim
          .fromTo(idOf("14-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg14Anim.stop();
        resetNumbers("14-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "2022 WORLD CHAMPIONSHIPS CAIRO, EGYPT 7 OF 7  Women’s Team Epee 1. Korea (gold) 2. Italy (silver) 3. Poland (bronze) July 22 Men’s Team Epee 1. France (gold) 2. Italy (silver) 3. Japan (bronze) Women’s Team Foil 1. Italy (gold) 2. USA (silver) 3. France (bronze) July 23 Men’s Team Foil 1. Italy (gold) 2. USA (silver) 3. France (bronze)  Tap here to view the ATHLETES' COMMISSION VOTE  Women’s Team Sabre 1. Hungary (gold) 2. France (silver) 3. Japan (bronze) ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": `
      <a href="http://www.gfencing.com" target="_blank">
        <div class="contentLinkNone" style="bottom: 189px; right: 614px; width: 228px; height: 38px;"></div>
      </a>
      <a href="mailto:sales@gfencing.com" target="_blank">
        <div class="contentLinkNone" style="bottom: 189px; right: 352px; width: 236px; height: 38px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
      <a href="http://www.gfencing.com" target="_blank">
        <img src="/121/en/static/_mobile/83-mobile-1.jpg">
      </a>
    `,      
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale197 16-title" style="top:101px;left:219px;" src="/121/en/static/_content/16-title-1.png">
      <img class="abs halfScale197 16-sub" style="top:252px;left:253px;" src="/121/en/static/_content/16-sub-1.png">
      <img class="abs halfScale197 16-line" style="top:252px;left:218px;" src="/121/en/static/_content/16-line-1.png">
      <img id="16-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg16Anim = new TimelineMax();
        pg16Anim
          .fromTo(cOf("16-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("16-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("16-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("16-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg16Anim.stop();
        resetNumbers("16-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  FRANCE’S LOPEZ POURTIER, TEAM HUNGARY WIN GOLD AT “CHALLENGE MONAL” EPEE WORLD CUP IN PARIS PARIS, FRANCE 15–17 APRIL 2022",
    "mobileHtml":`
    <h2>France’s Lopez Pourtier, Team Hungary Win Gold at “Challenge Monal” Epee World Cup in Paris</h2>
    <img src="/121/en/static/_mobile/16-mobile-1.png">
    <p><strong>Paris, France</strong><br>
    15–17 april 2022</p>
    <p>France’s Nelson Lopez Pourtier won the individual gold medal in men’s epee at the Challenge Monal in Paris, and Hungary won the men’s team gold. </p>
    <p>In individual men’s epee, Lopez Pourtier faced Kazakhstan’s Ruslan Kurbanov in the final round, winning with a 15-11 score. In the semifinal round, Kurbanov defeated France’s Alexandre Bardenet, 15-13, while Lopez Pourtier won against Hungary’s Mate Tamas Koch, 15-14. Of note, Bardenet beat teammate and Olympic champion Romain Cannone in the quarterfinals, 15-14, and Koch was the winner with Venezuelan Olympic champion Ruben Limardo Gascon in the round of 16, 13-9.</p>
    <p>In men’s team epee, Hungary won against France in the final match with a 45-36 score. France beat Japan in the semifinal round, 45-36, while Hungary beat Ukraine, 45-42. The bronze medal went to Ukraine over Japan, 40-39.</p>
    <p>Final rankings in individual men’s epee included Nelson Lopez Pourtier (FRA, gold), Ruslan Kurbanov (KAZ, silver), Alexandre Bardenet (FRA, bronze), Mate Tamas Koch (HUN, bronze), Romain Cannone (FRA), Mohamed Elsayed (EGY), Koki Kano (JPN) and Daniel Berta (HUN).</p>
    <p>Final rankings in men’s team epee included Hungary (gold), France, (silver), Ukraine (bronze), Japan, Kazakhstan, Egypt, USA and Korea.</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="17-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>

      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>

      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg17Anim = new TimelineMax();
        pg17Anim
          .fromTo(idOf("17-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg17Anim.stop();
        resetNumbers("17-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "quarterfinals, 15-14, and Koch was the winner with Venezuelan Olympic champion Ruben Limardo Gascon in the round of 16, 13-9.  EPEE GRAND PRIX PARIS, FRANCE, 2 OF 2  In men’s team epee, Hungary won against France in the final match with a 45-36 score. France beat Japan in the semifinal round, 45-36, while Hungary beat Ukraine, 4542. The bronze medal went to Ukraine over Japan, 40-39.  France’s Nelson Lopez Pourtier won the individual gold medal in men’s epee at the Challenge Monal in Paris, and Hungary won the men’s team gold. Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In individual men’s epee, Lopez Pourtier faced Kazakhstan’s Ruslan Kurbanov in the final round, winning with a 15-11 score. In the semifinal round, Kurbanov defeated France’s Alexandre Bardenet, 15-13, while Lopez Pourtier won against Hungary’s Mate Tamas Koch, 15-14. Of note, Bardenet beat teammate and Olympic champion Romain Cannone in the  Final rankings in individual men’s epee included Nelson Lopez Pourtier (FRA, gold), Ruslan Kurbanov (KAZ, silver), Alexandre Bardenet (FRA, bronze), Mate Tamas Koch (HUN, bronze), Romain Cannone (FRA), Mohamed Elsayed (EGY), Koki Kano (JPN) and Daniel Berta (HUN). Final rankings in men’s team epee included Hungary (gold), France, (silver), Ukraine (bronze), Japan, Kazakhstan, Egypt, USA and Korea. ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 18-title" style="top:78px;left:742px;" src="/121/en/static/_content/18-title-1.png">
      <img class="abs halfScale 18-sub" style="top:452px;left:779px;" src="/121/en/static/_content/18-sub-1.png">
      <img class="abs halfScale197 18-line" style="top:451px;left:745px;" src="/121/en/static/_content/18-line-1.png">
      <img id="18-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg18Anim = new TimelineMax();
        pg18Anim
          .fromTo(cOf("18-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("18-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("18-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("18-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg18Anim.stop();
        resetNumbers("18-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  ITALY’S MARINI, GERMANY’S SAUER WIN MEN’S AND WOMEN’S GOLD IN BELGRADE FOIL WORLD CUPS, ITALY AND FRANCE WIN TEAM FOIL BELGRADE, SERBIA 14–18 APRIL 2022",
    "searchText": "SP ORT  FRANCE’S LOPEZ POURTIER, TEAM HUNGARY WIN GOLD AT “CHALLENGE MONAL” EPEE WORLD CUP IN PARIS PARIS, FRANCE 15–17 APRIL 2022",
    "mobileHtml":`
    <h2>Italy’s Marini, Germany’s Sauer Win Men’s and Women’s Gold in Belgrade Foil World Cups, Italy and France Win Team Foil</h2>
    <img src="/121/en/static/_mobile/18-mobile-1.png">
    <p><strong>Belgrade, Serbia</strong><br>
    14–18 april 2022</p>
    <p>Italy’s Tommaso Marini and Germany’s Anne Sauer won gold medals in individual men’s and women’s foil at the Belgrade Foil World Cups, with Italy and France winning the team competitions. </p>
    <p>The event took place at the City’s Belexpocentar, with 213 men and 168 women participating 
    in the competitions.</p>
    <p>In individual men’s foil, Marini faced teammate Giorgio Avola in the final match, winning with a 15-9 score. In the semifinal round, Avola won against Japan’s Kazuki Iimura, 15-9, while Marini beat the Netherlands’ Daniel Giacon, 15-9. Avola also defeated Hong Kong, China Olympic champion Ka Long Cheung, 15-7, in the quarterfinals.</p>
    <p>In individual women’s foil, Sauer faced teammate Leonie Ebert in the final match, winning by a single touch, 15-14. Ebert defeated Italy’s Martina Batini in the semifinal round, 15-7, while Sauer won against USA’s Olympic champion, Lee Kiefer, 15-10. Ebert also beat Italian world champion Alice Volpi in the quarterfinals, 15-13, and Batini was the winner against teammate and two-time world champion Arianna Errigo, 15-12.</p>
    <p>In the men’s team foil event, with 28 teams participating, Italy won against Poland in the final round, 45-27. Poland defeated Hong Kong, China in the semifinal round, 45-32, while Italy beat France, 45-29. The bronze medal went to France over Hong Kong, China, 45-38.</p>
    <p>In the women’s team foil event, with 20 teams participating, France won against Germany in the final round, 45-30. Germany defeated Japan in the semifinal round, 39-34, while France beat Italy, 45-44. The bronze medal went to Italy over Japan, 45-15.</p>
    <p>Final rankings for individual men’s foil included Tommaso Marini (ITA, gold), Giorgio Avola (ITA, silver), Daniel Giacon (NED, bronze), Kazuki Iimura (JPN, bronze), Ka Long Cheung (HKG), Guilherme Toldo (BRA), Alexander Kahl (GER) and Marcus Mepstead (GBR).</p>
    <p>Final rankings for individual women’s foil included Anne Sauer (GER, gold), Leonie Ebert (GER, silver), Martina Batini (ITA, bronze), Lee Kiefer (USA, bronze), Alice Volpi (ITA), Arianna Errigo (ITA), Sera Azuma (JPN) and Julia Walczyk (POL).</p>
    <p>Final rankings for men’s team foil included Italy (gold); Poland (silver); France (bronze); Hong Kong, China; Japan; Egypt; Germany; and USA.</p>
    <p>Final rankings for women’s team foil included France (gold); Germany (silver); Italy (bronze); Japan; Korea; Spain; Canada; and Singapore.</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="19-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg19Anim = new TimelineMax();
        pg19Anim
          .fromTo(idOf("19-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg19Anim.stop();
        resetNumbers("19-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FOIL WORLD CUPS BELGRADE, SERBIA 2 OF 3  Italy’s Tommaso Marini and Germany’s Anne Sauer won gold medals in individual men’s and women’s foil at the Belgrade Foil World Cups, with Italy and France winning the team competitions. The event took place at the City’s Belexpocentar, with 213 men and 168 women participating in the competitions. In individual men’s foil, Marini faced teammate Giorgio Avola in the final match, winning with a 15-9 score. In the semifinal round, Avola  won against Japan’s Kazuki Iimura, 15-9, while Marini beat the Netherlands’ Daniel Giacon, 15-9. Avola also defeated Hong Kong, China Olympic champion Ka Long Cheung, 15-7, in the quarterfinals. In individual women’s foil, Sauer faced teammate Leonie Ebert in the final match, winning by a single touch, 15-14. Ebert defeated Italy’s Martina Batini in the semifinal round, 15-7, while Sauer won against USA’s Olympic champion, Lee Kiefer, 15-10. Ebert also beat Italian world champion Alice Volpi in the quarterfinals, 15-13, and Batini was the winner against teammate and two-time world champion Arianna Errigo, 15-12."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="20-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg20Anim = new TimelineMax();
        pg20Anim
          .fromTo(idOf("20-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg20Anim.stop();
        resetNumbers("20-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "silver), Daniel Giacon (NED, bronze), Kazuki Iimura (JPN, bronze), Ka Long Cheung (HKG), Guilherme Toldo (BRA), Alexander Kahl (GER) and Marcus Mepstead (GBR).  FOIL WORLD CUPS BELGRADE, SERBIA 3 OF 3  Final rankings for individual women’s foil included Anne Sauer (GER, gold), Leonie Ebert (GER, silver), Martina Batini (ITA, bronze), Lee Kiefer (USA, bronze), Alice Volpi (ITA), Arianna Errigo (ITA), Sera Azuma (JPN) and Julia Walczyk (POL). In the men’s team foil event, with 28 teams participating, Italy won against Poland in the final round, 45-27. Poland defeated Hong Kong, China in the semifinal round, 45-32, while Italy beat France, 45-29. The bronze medal went to France over Hong Kong, China, 45-38.  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In the women’s team foil event, with 20 teams participating, France won against Germany in the final round, 45-30. Germany defeated Japan in the semifinal round, 39-34, while France beat Italy, 45-44. The bronze medal went to Italy over Japan, 45-15.  Final rankings for men’s team foil included Italy (gold); Poland (silver); France (bronze); Hong Kong, China; Japan; Egypt; Germany; and USA. Final rankings for women’s team foil included France (gold); Germany (silver); Italy (bronze); Japan; Korea; Spain; Canada; and Singapore. ■  Final rankings for individual men’s foil included Tommaso Marini (ITA, gold), Giorgio Avola (ITA,  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 21-title" style="top:78px;left:369px;" src="/121/en/static/_content/21-title-1.png">
      <img class="abs halfScale 21-sub" style="top:231px;left:525px;" src="/121/en/static/_content/21-sub-1.png">
      <img class="abs halfScale 21-line" style="top:231px;left:492px;" src="/121/en/static/_content/21-line-1.png">
      <img id="21-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg21Anim = new TimelineMax();
        pg21Anim
          .fromTo(cOf("21-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("21-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("21-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("21-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg21Anim.stop();
        resetNumbers("21-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  FRANCE’S BOREL, KOREA’S CHOI WIN CAIRO MEN’S AND WOMEN’S EPEE GRAND PRIX CAIRO, EGYPT 29 APRIL–1 MAY 2022",
    "mobileHtml":`
    <h2>France’s Borel, Korea’s Choi Win Cairo Men’s and Women’s Epee Grand Prix</h2>
    <img src="/121/en/static/_mobile/21-mobile-1.png">

    <p><strong>Cairo, Egypt</strong><br>
    29 April–1 May 2022</p>
    <p>France’s world champion Yannick Borel and Korea’s Injeong Choi won gold medals at the Cairo Men’s and Women’s Epee Grand Prix. </p>
    <p>The competition took place at the Cairo Stadium Indoor Halls Complex, with 179 men and 138 women participating.</p>
    <p>In the men’s epee event, Borel faced teammate Nelson Lopez Pourtier, winning with a 15-5 score. Lopez Pourtier won against teammate Alex Fava in the semifinal round, 9-8, while Borel defeated Hungarian world champion Gergely Siklosi, 15-10.</p>
    <p>In the women’s epee event, Choi faced France’s Auriane Mallo, winning with a 15-14 score. 
    Mallo won against USA’s Katharine Holmes in the semifinal round, 15-9, while Choi beat teammate Sera Song, 11-10. Of note, Choi also defeated two-time Italian world champion Rossella Fiamingo in the quarterfinals, 15-11, and Mallo won against Brazilian world champion Nathalie Moellhausen in the round of 16, 15-14.</p>
    <p>Final rankings in men’s epee included Yannick Borel (FRA, gold), Nelson Lopez Pourtier (FRA, silver), Alex Fava (FRA, bronze), Gergely Siklosi (HUN, bronze), Andrea Santarelli (ITA), Houssam Elkord (MAR), Max Heinzer (SUI) and Davide Di Veroli (ITA).</p>
    <p>Final rankings in women’s epee included Injeong Choi (KOR, gold), Auriane Mallo (FRA, silver), Katharine Holmes (USA, bronze), Sera Song (KOR, bronze), Rossella Fiamingo (ITA), Anna Kun (HUN), Kristina Kuusk (EST) and Lauren Rembi (FRA). </p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="22-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg22Anim = new TimelineMax();
        pg22Anim
          .fromTo(idOf("22-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg22Anim.stop();
        resetNumbers("22-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "EPEE GRAND PRIX CAIRO, EGYPT 2 OF 3  France’s world champion Yannick Borel and Korea’s Injeong Choi won gold medals at the Cairo Men’s and Women’s Epee Grand Prix. The competition took place at the Cairo Stadium Indoor Halls Complex, with 179 men and 138 women participating. In the men’s epee event, Borel faced teammate Nelson Lopez Pourtier, winning with a 15-5 score. Lopez Pourtier won against teammate  Alex Fava in the semifinal round, 9-8, while Borel defeated Hungarian world champion Gergely Siklosi, 15-10. In the women’s epee event, Choi faced France’s Auriane Mallo, winning with a 15-14 score. Mallo won against USA’s Katharine Holmes in the semifinal round, 15-9, while Choi beat teammate Sera Song, 11-10. Of note, Choi also defeated two-time Italian world champion Rossella Fiamingo in the quarterfinals, 15-11, and Mallo won against Brazilian world champion Nathalie Moellhausen in the round of 16, 15-14."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="23-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg23Anim = new TimelineMax();
        pg23Anim
          .fromTo(idOf("23-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg23Anim.stop();
        resetNumbers("23-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "EPEE GRAND PRIX CAIRO, EGYPT 3 OF 3  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  Final rankings in men’s epee included Yannick Borel (FRA, gold), Nelson Lopez Pourtier (FRA, silver), Alex Fava (FRA, bronze), Gergely Siklosi (HUN, bronze), Andrea Santarelli (ITA), Houssam Elkord (MAR), Max Heinzer (SUI) and Davide Di Veroli (ITA).  Final rankings in women’s epee included Injeong Choi (KOR, gold), Auriane Mallo (FRA, silver), Katharine Holmes (USA, bronze), Sera Song (KOR, bronze), Rossella Fiamingo (ITA), Anna Kun (HUN), Kristina Kuusk (EST) and Lauren Rembi (FRA). ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": `
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
        <img src="/121/en/static/_mobile/24-mobile-1.jpg">
    `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 25-title" style="top:101px;left:492px;" src="/121/en/static/_content/25-title-1.png">
      <img class="abs halfScale 25-sub" style="top:255px;left:526px;" src="/121/en/static/_content/25-sub-1.png">
      <img class="abs halfScale 25-line" style="top:254px;left:490px;" src="/121/en/static/_content/31-line-1.png">
      <img id="25-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg25Anim = new TimelineMax();
        pg25Anim
          .fromTo(cOf("25-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("25-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("25-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("25-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg25Anim.stop();
        resetNumbers("25-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  KOREA WINS DOUBLE GOLD AT “VILLA DE MADRID” MEN’S SABRE WORLD CUP MADRID, SPAIN 6–8 MAY 2022",
    "mobileHtml":`
    <h2>Korea Wins Double Gold at “Villa de Madrid” Men’s Sabre World Cup</h2>
    <img src="/121/en/static/_mobile/25-mobile-1.png">
    <p><strong>Madrid, Spain</strong><br>
    6-8 May 2022</p>
    <p>Korean world champion Sanguk Oh won the gold medal at the “Villa de Madrid” Men’s Sabre World Cup, with Korea also winning the men’s team event. </p>
    <p>In the final match, Oh faced Italy’s Luca Curatoli, winning with a 15-11 score. In the semifinal round, Curatoli won against Georgia’s Sandro Bazadze, 15-14, while Oh defeated his teammate and world champion Junghwan Kim, 15-10. Of note, Hungarian three-time Olympic champion Aron Szilagyi beat teammate and world champion Andras Szatmari in the round of 16, 15-14, and then, in another close match, lost to Curatoli in the quarterfinals, 15-14.</p>
    <p>In men’s team sabre, Korea won against Hungary in the final round, 45-32. In the semifinals, Hungary beat Italy, 45-38, while Korea defeated Germany, 45-38. The bronze medal went to Italy over Germany, 45-35.</p>
    <p>Final rankings for individual men’s sabre included Sanguk Oh (KOR, gold), Luca Curatoli (ITA, silver), Sandro Bazadze (GEO, bronze), Junghwan Kim (KOR, bronze), Aron Szilagyi (HUN), Eli Dershwitz (USA), Mohamed Amer (EGY) and Michele Gallo (ITA).</p>
    <p>Final rankings for men’s team sabre included Korea (gold), Hungary (silver), Italy (bronze), Germany, France, Georgia, USA and Canada.</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="26-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg26Anim = new TimelineMax();
        pg26Anim
          .fromTo(idOf("26-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg26Anim.stop();
        resetNumbers("27-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SABRE WORLD CUP MADRID, SPAIN 2 OF 2  Korean world champion Sanguk Oh won the gold medal at the “Villa de Madrid” Men’s Sabre World Cup, with Korea also winning the men’s team event. In the final match, Oh faced Italy’s Luca Curatoli, winning with a 15-11 score. In the semifinal round, Curatoli won against Georgia’s Sandro Bazadze, 15-14, while Oh defeated his teammate and world champion Junghwan Kim, 15-10. Of note, Hungarian three-time Olympic champion Aron Szilagyi beat teammate and world champion Andras Szatmari in the round of 16, 15-14, and then, in another close match, lost to Curatoli in the quarterfinals, 15-14.  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In men’s team sabre, Korea won against Hungary in the final round, 45-32. In the semifinals, Hungary beat Italy, 45-38, while  Korea defeated Germany, 45-38. The bronze medal went to Italy over Germany, 45-35. Final rankings for individual men’s sabre included Sanguk Oh (KOR, gold), Luca Curatoli (ITA, silver), Sandro Bazadze (GEO, bronze), Junghwan Kim (KOR, bronze), Aron Szilagyi (HUN), Eli Dershwitz (USA), Mohamed Amer (EGY) and Michele Gallo (ITA). Final rankings for men’s team sabre included Korea (gold), Hungary (silver), Italy (bronze), Germany, France, Georgia, USA and Canada. ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 27-title" style="top:66px;left:106px;" src="/121/en/static/_content/27-title-1.png">
      <img class="abs halfScale 27-sub" style="top:176px;left:526px;" src="/121/en/static/_content/27-sub-1.png">
      <img class="abs halfScale 27-line" style="top:173px;left:492px;" src="/121/en/static/_content/27-line-1.png">
      <img id="27-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg27Anim = new TimelineMax();
        pg27Anim
          .fromTo(cOf("27-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("27-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("27-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("27-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg27Anim.stop();
        resetNumbers("27-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  JAPAN’S EMURA, TEAM KOREA WIN GOLD AT WOMEN’S SABRE WORLD CUP IN TUNISIA HAMMAMET, TUNISIA 6–8 MAY 2022",
    "mobileHtml":`
    <h2>Japan’s Emura, Team Korea Win Gold at Women’s Sabre World Cup in Tunisia</h2>
    <img src="/121/en/static/_mobile/27-mobile-1.png">
    <p><strong>Hammamet, Tunisia</strong><br>
    6-8 May 2022</p>
    <p>Japan’s Misaki Emura won the individual gold medal at the Tunisia Women’s Sabre World Cup, and Korea won the team gold. </p>
    <p>The event took place at the Hammamet Medina Conference and Expo Center, with 179 individual fencers and 26 teams participating in the competition.</p>
    <p>Emura faced Greece’s Despina Georgiadou in the final match of the individual event, winning with a 15-13 score. In the semifinal round, Georgiadou won against France’s Manon Apithy-Brunet, 15-9, while Emura beat her teammate, Kanae Kobayashi, 15-12. Of note, Romania’s Sabina Martis defeated Ukrainian four-time world champion Olga Kharlan in the round of 16, 15-11, followed by Apithy-Brunet winning against Martis in the quarterfinals, 15-10.</p>
    <p>In the women’s team sabre event, Korea won against Japan in the final match, 45-25. Japan defeated France in the semifinals, 45-30, while Korea beat Italy, 45-31. The bronze medal went to France over Italy, 45-31.</p>
    <p>Final rankings in individual women’s sabre included Misaki Emura (JPN, gold), Despina Georgiadou (GRE, silver), Manon Apithy-Brunet (FRA, bronze), Kanae Kobayashi (JPN, 
      bronze), Sarah Noutcha (FRA), Sabina Martis (ROU), Caroline Queroli (FRA) and Yuliia Bakastova (UKR).</p>
    <p>Final rankings in women’s team sabre included Korea (gold), Japan (silver), France (bronze), Italy, Azerbaijan, Poland, Hungary and Bulgaria.</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="28-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg28Anim = new TimelineMax();
        pg28Anim
          .fromTo(idOf("28-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg28Anim.stop();
        resetNumbers("29-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SABRE WORLD CUP HAMMAMET, TUNISIA 2 OF 2  Japan’s Misaki Emura won the individual gold medal at the Tunisia Women’s Sabre World Cup, and Korea won the team gold. The event took place at the Hammamet Medina Conference and Expo Center, with 179 individual fencers and 26 teams participating in the competition. Emura faced Greece’s Despina Georgiadou in the final match of the individual event, winning  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  with a 15-13 score. In the semifinal round, Georgiadou won against France’s Manon ApithyBrunet, 15-9, while Emura beat her teammate, Kanae Kobayashi, 15-12. Of note, Romania’s Sabina Martis defeated Ukrainian four-time world champion Olga Kharlan in the round of 16, 15-11, followed by Apithy-Brunet winning against Martis in the quarterfinals, 15-10. In the women’s team sabre event, Korea won against Japan in the final match, 45-25. Japan defeated France in the semifinals, 45-30, while Korea beat Italy, 45-31. The bronze medal went to France over Italy, 45-31. Final rankings in individual women’s sabre included Misaki Emura (JPN, gold), Despina Georgiadou (GRE, silver), Manon ApithyBrunet (FRA, bronze), Kanae Kobayashi (JPN, bronze), Sarah Noutcha (FRA), Sabina Martis (ROU), Caroline Queroli (FRA) and Yuliia Bakastova (UKR). Final rankings in women’s team sabre included Korea (gold), Japan (silver), France (bronze), Italy, Azerbaijan, Poland, Hungary and Bulgaria. ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 29-title" style="top:69px;left:219px;" src="/121/en/static/_content/29-title-1.png">
      <img class="abs halfScale 29-sub" style="top:178px;left:253px;" src="/121/en/static/_content/29-sub-1.png">
      <img class="abs halfScale 29-line" style="top:177px;left:219px;" src="/121/en/static/_content/29-line-1.png">
      <img id="29-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg29Anim = new TimelineMax();
        pg29Anim
          .fromTo(cOf("29-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("29-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("29-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("29-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg29Anim.stop();
        resetNumbers("29-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  FRANCE’S CANNONE, TEAM KOREA WIN HEIDENHEIM MEN’S EPEE WORLD CUP HEIDENHEIM, GERMANY 13–14 MAY 2022",
    "mobileHtml":`
    <h2>France’s Cannone, Team Korea Win Heidenheim Men’s Epee World Cup</h2>
    <img src="/121/en/static/_mobile/29-mobile-1.png">
    <p><strong>Heidenheim, Germany</strong><br>
    13-14 May 2022</p>
    <p>Korean world champion Sanguk Oh won the gold medal at the “Villa de Madrid” Men’s Sabre World Cup, with Korea also winning the men’s team event. </p>
    <p>In the final match, Oh faced Italy’s Luca Curatoli, winning with a 15-11 score. In the semifinal round, Curatoli won against Georgia’s Sandro Bazadze, 15-14, while Oh defeated his teammate and world champion Junghwan Kim, 15-10. Of note, Hungarian three-time Olympic champion Aron Szilagyi beat teammate and world champion Andras Szatmari in the round of 16, 15-14, and then, in another close match, lost to Curatoli in the quarterfinals, 15-14.</p>
    <p>In men’s team sabre, Korea won against Hungary in the final round, 45-32. In the semifinals, Hungary beat Italy, 45-38, while Korea defeated Germany, 45-38. The bronze medal went to Italy over Germany, 45-35.</p>
    <p>Final rankings for individual men’s sabre included Sanguk Oh (KOR, gold), Luca Curatoli (ITA, silver), Sandro Bazadze (GEO, bronze), Junghwan Kim (KOR, bronze), Aron Szilagyi (HUN), Eli Dershwitz (USA), Mohamed Amer (EGY) and Michele Gallo (ITA).</p>
    <p>Final rankings for men’s team sabre included Korea (gold), Hungary (silver), Italy (bronze), Germany, France, Georgia, USA and Canada.</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="30-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg30Anim = new TimelineMax();
        pg30Anim
          .fromTo(idOf("30-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg30Anim.stop();
        resetNumbers("30-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "EPEE WORLD CUP HEIDENHEIM, GERMANY 2 OF 2  France’s Olympic champion Romain Cannone won the individual gold medal at the Heidenheim Men’s Epee World Cup, with Korea winning men’s team epee. The competition, which was held at the City’s Karl-Rau-Halle, included 261 individual fencers and 35 teams participating.  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  Cannone faced Morocco’s Houssam Elkord in the final match of the men’s individual epee event, the “Heidenheimer Pokal”, winning with a 15-11 score. In the semifinal round, Elkord won against Italy’s Gabriele Cimini, 15-14, while Cannone defeated Hungary’s Mate Tamas Koch, 15-9. Of note, Koch beat French world champion Yannick Borel in the quarterfinals, 15-11, and Venezuelan Olympic champion Ruben Limardo Gascon in the round of 16, 11-9.  Final rankings in individual men’s epee included Romain Cannone (FRA, gold), Houssam Elkord (MAR, silver), Gabriele Cimini (ITA, bronze), Mate Tamas Koch (HUN, bronze), Andrea Santarelli (ITA), Yannick Borel (FRA), Curtis McDowald (USA) and Minghao Lan (CHN). Final rankings in men’s team epee included Korea (gold), Germany (silver), France (bronze), Hungary, Ukraine, USA, Italy and Switzerland. ■  In the men’s team epee event, the “Voith Cup”, Korea won against Germany in the final match, 45-32. In the semifinal round, Germany defeated France, 45-30, while Korea beat Hungary, 37-36. The bronze medal went to France over Hungary, 45-43.  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 31-title" style="top:94px;left:768px;" src="/121/en/static/_content/31-title-1.png">
      <img class="abs halfScale 31-sub" style="top:289px;left:799px;" src="/121/en/static/_content/31-sub-1.png">
      <img class="abs halfScale 31-line" style="top:288px;left:766px;" src="/121/en/static/_content/31-line-1.png">
      <img id="31-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg31Anim = new TimelineMax();
        pg31Anim
          .fromTo(cOf("31-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("31-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("31-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("31-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg31Anim.stop();
        resetNumbers("31-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  ITALY’S MARINI, USA’S KIEFER WIN INCHEON FOIL GRAND PRIX INCHEON, KOREA 13–15 MAY 2022",
    "mobileHtml":`
    <h2>Italy’s Marini, USA’s Kiefer Win Incheon Foil Grand Prix</h2>
      <img src="/121/en/static/_mobile/31-mobile-1.png">
      <p><strong>Incheon, Korea</strong><br>
    13-15 May 2022</p>
    <p>Korean world champion Sanguk Oh won the gold medal at the “Villa de Madrid” Men’s Sabre World Cup, with Korea also winning the men’s team event. </p>
    <p>Italy’s Tommaso Marini and USA’s Olympic champion Lee Kiefer won the gold medals at the 2022 SK Telecom Incheon Foil Grand Prix. </p>
    <p>The event took place at the Incheon Namdong Gym, with 119 men and 110 women participating.</p>
    <p>Marini faced Hong Kong, China’s Chun Yin Ryan Choi in the final match of individual men’s foil, winning the gold medal by a single touch, 15-14. In the semifinal round, Choi won against Italian world champion Alessio Foconi, 15-14, while Marini defeated France’s Maximilien Chastanet, 15-13. Of note, France’s Rafael Savin beat USA world champion Miles Chamley-Watson in the round of 16, 15-13, before being defeated by Choi in the quarterfinals, 15-14. Choi also defeated French world champion Enzo Lefort in the round of 16, 15-9.</p>
    <p>Kiefer faced Canada’s Eleanor Harvey in the final match of individual women’s foil, winning the gold medal with a 15-11 score. In the semifinal round, Harvey won against Italy’s world champion Alice Volpi, 15-13, while Kiefer defeated Germany’s Anne Sauer, 15-5. Of note, Italy’s Francesca Palumbo beat teammate and two-time world champion Arianna Errigo in the round of 16, 15-14, before being defeated by Harvey in the quarterfinals, 13-7.</p>
    <p>Final rankings in men’s foil included Tommaso Marini (ITA, gold), Chun Yin Ryan Choi (HKG, silver), Maximilien Chastanet (FRA, bronze), Alessio Foconi (ITA, bronze), Alaaeldin Abouelkassem (EGY), Rafael Savin (FRA), Carlos Llavador (ESP) and Marcus Mepstead (GBR).</p>
    <p>Final rankings in women’s foil included Lee Kiefer (USA, gold), Eleanor Harvey (CAN, silver), Anne Sauer (GER, bronze), Alice Volpi (ITA, bronze), Ysaora Thibus (FRA), Jessica Zi Jia Guo (CAN), Francesca Palumbo (ITA) and Jacqueline Dubrovich (USA).</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="32-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg32Anim = new TimelineMax();
        pg32Anim
          .fromTo(idOf("32-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg32Anim.stop();
        resetNumbers("32-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FOIL GRAND PRIX INCHEON, KOREA 2 OF 2  Italy’s Tommaso Marini and USA’s Olympic champion Lee Kiefer won the gold medals at the 2022 SK Telecom Incheon Foil Grand Prix. The event took place at the Incheon Namdong Gym, with 119 men and 110 women participating.  Tap here to view the RESULTS  Marini faced Hong Kong, China’s Chun Yin Ryan Choi in the final match of individual men’s foil, winning the gold medal by a single touch, 15-14. In the semifinal round, Choi won against Italian world champion Alessio Foconi, 15-14, while Marini defeated France’s Maximilien Chastanet, 15-13. Of note, France’s Rafael Savin beat USA world champion Miles Chamley-Watson in the round of 16, 15-13, before being defeated by Choi in the quarterfinals, 15-14. Choi also defeated French world champion Enzo Lefort in the round of 16, 15-9.  TAP HERE to link to our FIE YouTube series  Kiefer faced Canada’s Eleanor Harvey in the final match of individual women’s foil, winning the gold medal with a 15-11 score. In the semifinal round, Harvey won against Italy’s world champion Alice Volpi, 15-13, while Kiefer  defeated Germany’s Anne Sauer, 15-5. Of note, Italy’s Francesca Palumbo beat teammate and two-time world champion Arianna Errigo in the round of 16, 15-14, before being defeated by Harvey in the quarterfinals, 13-7. Final rankings in men’s foil included Tommaso Marini (ITA, gold), Chun Yin Ryan Choi (HKG, silver), Maximilien Chastanet (FRA, bronze), Alessio Foconi (ITA, bronze), Alaaeldin Abouelkassem (EGY), Rafael Savin (FRA), Carlos Llavador (ESP) and Marcus Mepstead (GBR). Final rankings in women’s foil included Lee Kiefer (USA, gold), Eleanor Harvey (CAN, silver), Anne Sauer (GER, bronze), Alice Volpi (ITA, bronze), Ysaora Thibus (FRA), Jessica Zi Jia Guo (CAN), Francesca Palumbo (ITA) and Jacqueline Dubrovich (USA). ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": `
      <a href="https://www.blaise-freres.fr" target="_blank">
        <div class="contentLinkNone" style="bottom: 179px; right: 1002px; width: 177px; height: 20px; "></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
      <a href="https://www.blaise-freres.fr" target="_blank">
        <img src="/121/en/static/_mobile/33-mobile-1.jpg">
      </a>
    `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 34-title" style="top:85px;left:66px;" src="/121/en/static/_content/34-title-1.png">
      <img class="abs halfScale 34-sub" style="top:237px;left:99px;" src="/121/en/static/_content/34-sub-1.png">
      <img class="abs halfScale 34-line" style="top:234px;left:66px;" src="/121/en/static/_content/34-line-1.png">
      <img id="34-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg34Anim = new TimelineMax();
        pg34Anim
          .fromTo(cOf("34-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("34-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("34-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("34-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg34Anim.stop();
        resetNumbers("34-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  HUNGARY’S SZILAGYI, AZERBAIJAN’S BASHTA WIN GOLD AT PADUA SABRE GRAND PRIX PADUA, ITALY 20–22 MAY 2022",
    "mobileHtml":`
    <h2>Hungary’s Szilagyi, Azerbaijan’s Bashta Win Gold at Padua Sabre Grand Prix</h2>
      <img src="/121/en/static/_mobile/34-mobile-1.png">
      <p><strong>Padua, Italy</strong><br>
    20-22 May 2022</p>
    <p>Hungary’s three-time Olympic champion Aron Szilagyi and Azerbaijan’s Anna Bashta won the men’s and women’s gold medals at the 63rd Padua “Trofeo Luxardo” Sabre Grand Prix. </p>
    <p>The event took place at the City’s Palaindoor di Padova sports complex with 195 men and 160 women competing.</p>
    <p>In men’s individual sabre, Szilagyi faced Korea’s Bongil Gu in the final round, winning the gold by a single point, 15-14. In the semifinal round, Gu won against France’s Bolade Apithy, 15-14, while Szilagyi defeated France’s Eliott Bibi, 15-9. Of note, Bibi beat Hungarian world champion Andras Szatmari in the quarterfinals, 15-11, and Korea’s Junho Kim won against teammate and world champion Sanguk Oh in the round of 16, 15-13, before being defeated by Apithy in the quarterfinals, 15-13.</p>
    <p>In women’s individual sabre, Bashta faced Japan’s Risa Takashima in the final round, winning the gold with a 15-11 score. In the semifinal round, Takashima won against France’s Caroline Queroli, 15-12, and Bashta beat Japan’s Misaki Emura, 15-9. Of note, Korea’s Hayoung Jeon defeated Ukraine’s four-time world champion, Olga Kharlan, in the round of 16, 15-14, before being beaten by Takashima in the quarterfinals, 15-8.</p>
    <p>Final rankings in men’s sabre included Aron Szilagyi (HUN, gold), Bongil Gu (KOR, silver), Bolade Apithy (FRA, bronze), Eliott Bibi (FRA, bronze), Andras Szatmari (HUN), Junho Kim (KOR), Iulian Teodosiu (ROU) and Maxime Pianfetti (FRA).</p>
    <p>Final rankings in women’s sabre included Anna Bashta (AZE, gold), Risa Takashima (JPN, silver), Misaki Emura (JPN, bronze), Caroline Queroli (FRA, bronze), Rossella Gregorio (ITA), Sooyeon Choi (KOR), Hayoung Jeon (KOR) and Araceli Navarro (ESP).</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="35-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg35Anim = new TimelineMax();
        pg35Anim
          .fromTo(idOf("35-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg35Anim.stop();
        resetNumbers("35-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SABRE GRAND PRIX PADUA, ITALY 2 OF 3  Hungary’s three-time Olympic champion Aron Szilagyi and Azerbaijan’s Anna Bashta won the men’s and women’s gold medals at the 63rd Padua “Trofeo Luxardo” Sabre Grand Prix. The event took place at the City’s Palaindoor di Padova sports complex with 195 men and 160 women competing. In men’s individual sabre, Szilagyi faced Korea’s Bongil Gu in the final round, winning the gold by a single point, 15-14. In the semifinal round, Gu won against France’s Bolade Apithy, 15-14, while Szilagyi defeated France’s Eliott  Bibi, 15-9. Of note, Bibi beat Hungarian world champion Andras Szatmari in the quarterfinals, 15-11, and Korea’s Junho Kim won against teammate and world champion Sanguk Oh in the round of 16, 15-13, before being defeated by Apithy in the quarterfinals, 15-13. In women’s individual sabre, Bashta faced Japan’s Risa Takashima in the final round,"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="36-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg36Anim = new TimelineMax();
        pg36Anim
          .fromTo(idOf("36-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg36Anim.stop();
        resetNumbers("36-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "Bolade Apithy (FRA, bronze), Eliott Bibi (FRA, bronze), Andras Szatmari (HUN), Junho Kim (KOR), Iulian Teodosiu (ROU) and Maxime Pianfetti (FRA).  SABRE GRAND PRIX PADUA, ITALY 3 OF 3  Final rankings in women’s sabre included Anna Bashta (AZE, gold), Risa Takashima (JPN, silver), Misaki Emura (JPN, bronze), Caroline Queroli (FRA, bronze), Rossella Gregorio (ITA), Sooyeon Choi (KOR), Hayoung Jeon (KOR) and Araceli Navarro (ESP). ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  winning the gold with a 15-11 score. In the semifinal round, Takashima won against France’s Caroline Queroli, 15-12, and Bashta beat Japan’s Misaki Emura, 15-9. Of note, Korea’s Hayoung Jeon defeated Ukraine’s four-time world champion, Olga Kharlan, in the round of 16, 15-14, before being beaten by Takashima in the quarterfinals, 15-8. Final rankings in men’s sabre included Aron Szilagyi (HUN, gold), Bongil Gu (KOR, silver),  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 37-title" style="top:145px;left:66px;" src="/121/en/static/_content/37-title-1.png">
      <img class="abs halfScale 37-sub" style="top:474px;left:98px;" src="/121/en/static/_content/37-sub-1.png">
      <img class="abs halfScale 37-line" style="top:471px;left:66px;" src="/121/en/static/_content/37-line-1.png">
      <img id="37-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg37Anim = new TimelineMax();
        pg37Anim
          .fromTo(cOf("37-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("37-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("37-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("37-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg37Anim.stop();
        resetNumbers("37-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  UKRAINE’S STANKEVYCH, TEAM SWITZERLAND WIN TBILISI MEN’S EPEE WORLD CUP TBILISI, GEORGIA 27–29 MAY 2022",
    "mobileHtml":`
    <h2>Ukraine’s Stankevych, Team Switzerland Win Tbilisi Men’s Epee World Cup</h2>
      <img src="/121/en/static/_mobile/37-mobile-1.png">
      <p><strong>Tbilisi, Georgia</strong><br>
    27–29 May 2022</p>
    <p>Ukraine’s Volodymyr Stankevych won the individual gold medal at the Tbilisi Men’s Epee World Cup, with Switzerland winning men’s team epee. </p>
    <p>The competition, which was held at the Tbilisi Sports Palace, included 179 individual fencers and 25 teams participating.</p>
    <p>Stankevych faced Hungary’s Mate Tamas Koch in the final match of the men’s individual epee event, winning with a 15-9 score. In the semifinal round, Koch won against Ukraine’s Igor Reizlin, 15-9, while Stankevych defeated Japan’s Inochi Ito, 15-10. Of note, Italy’s Federico Vismara beat France’s Olympic champion, Romain Cannone, in the round of 16, 15-14, before being defeated by Reizlin in the quarterfinals, 15-8. Also in the 16, France’s Nelson Lopez Pourtier defeated teammate and world champion Yannick Borel, 15-14, before being beaten by Ito in the quarterfinals, 12-11.</p>
    <p>In the men’s team epee event, Switzerland won against France in the final match, 45-35. In the semifinal round, France defeated Italy, 44-41, while Switzerland beat Hungary, 45-40. The bronze medal went to Hungary over Italy, 44-38.</p>
    <p>Final rankings in men’s individual epee included Volodymyr Stankevych (UKR, gold), Mate Tamas Koch (HUN, silver), Inochi Ito (JPN, bronze), Igor Reizlin (UKR, bronze), Nelson Lopez Pourtier (FRA), Koki Kano (JPN), Federico Vismara (ITA) and Tibor Andrasfi (HUN).</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="38-next" class="halfScale197 pointer" style="top:658px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg38Anim = new TimelineMax();
        pg38Anim
          .fromTo(idOf("38-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg38Anim.stop();
        resetNumbers("38-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "EPEE GRAND PRIX TBILISI, GEORGIA 2 OF 3  Ukraine’s Volodymyr Stankevych won the individual gold medal at the Tbilisi Men’s Epee World Cup, with Switzerland winning men’s team epee. The competition, which was held at the Tbilisi Sports Palace, included 179 individual fencers and 25 teams participating. Stankevych faced Hungary’s Mate Tamas Koch in the final match of the men’s individual epee event, winning with a 15-9 score. In the semifinal round, Koch won against Ukraine’s Igor Reizlin, 15-9, while Stankevych defeated Japan’s Inochi Ito, 15-10. Of note, Italy’s Federico Vismara beat France’s Olympic champion, Romain Cannone, in the round of 16, 15-14, before being defeated by Reizlin in the quarterfinals, 15-8. Also in the 16, France’s Nelson Lopez Pourtier defeated teammate and world champion Yannick Borel, 15-14, before being beaten by Ito in the quarterfinals, 12-11. In the men’s team epee event, Switzerland won against France in the final match, 45-35."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="39-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg39Anim = new TimelineMax();
        pg39Anim
          .fromTo(idOf("39-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg39Anim.stop();
        resetNumbers("39-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "EPEE GRAND PRIX TBILISI, GEORGIA 3 OF 3  In the semifinal round, France defeated Italy, 44-41, while Switzerland beat Hungary, 4540. The bronze medal went to Hungary over Italy, 44-38. Final rankings in men’s individual epee included Volodymyr Stankevych (UKR, gold), Mate Tamas Koch (HUN, silver), Inochi Ito (JPN, bronze), Igor  Reizlin (UKR, bronze), Nelson Lopez Pourtier (FRA), Koki Kano (JPN), Federico Vismara (ITA) and Tibor Andrasfi (HUN). Final rankings in men’s team epee included Switzerland (gold), France (silver), Hungary (bronze), Italy, Israel, USA, Ukraine and Korea. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": `
        <a href="https://www.facebook.com/uhlmann.fencing/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 1117px; width: 19px; height: 18px;"></div>
        </a>
        <a href="https://www.instagram.com/uhlmann.fencing/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 1096px; width: 19px; height: 18px;"></div>
        </a>
        <a href="https://uhlmann-fechtsport.com/en/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 988px; width: 104px; height: 18px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://uhlmann-fechtsport.com/en/" target="_blank">
          <img src="/121/en/static/_mobile/40-mobile-1.jpg">
        </a>
      `,      
    "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 41-title" style="top:100px;left:493px;" src="/121/en/static/_content/41-title-1.png">
      <img class="abs halfScale 41-sub" style="top:253px;left:728px;" src="/121/en/static/_content/41-sub-1.png">
      <img class="abs halfScale 41-line" style="top:252px;left:694px;" src="/121/en/static/_content/41-line-1.png">
      <img id="41-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg41Anim = new TimelineMax();
        pg41Anim
          .fromTo(cOf("41-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("41-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("41-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("41-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg41Anim.stop();
        resetNumbers("41-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  KOREA TAKES DOUBLE GOLD AT KATOWICE WOMEN’S EPEE WORLD CUP KATOWICE, POLAND 27–29 MAY 2022",
    "mobileHtml":`
    <h2>Korea Takes Double Gold at Katowice Women’s Epee World Cup</h2>
    <img src="/121/en/static/_mobile/41-mobile-1.png">
    <p><strong>Katowice, Poland</strong><br>
    27–29 May 2022</p>
    <p>Korea’s Injeong Choi won the individual gold medal at the Katowice Women’s Epee World 
    Cup, with Korea winning women’s team epee.</p>
    <p>The competition, which was held at the Katowice Academy of Physical Education, included 187 individual fencers and 19 teams.</p>
    <p>Choi faced Italy’s Alberta Santuccio in the final match of the women’s individual epee event, winning with a 15-10 score. In the semifinal round, Santuccio won against Hungary’s Anna Kun, 15-10, while Choi defeated France’s Marie-Florence Candassamy, 15-12.</p>
    <p>In the women’s team epee event, Korea won against China in the final match, 34-29. In the semifinal round, China defeated Poland, 45-29, while Korea beat USA, 35-34. The bronze medal went to USA over Poland, 39-33.</p>
    <p>Final rankings in women’s individual epee included Injeong Choi (KOR, gold), Alberta Santuccio (ITA, silver), Anna Kun (HUN, bronze), Marie-Florence Candassamy (FRA, bronze), Nelli Differt (EST), Martyna Swatowska-Wenglarczyk (POL), Irina Embrich (EST) and Roberta Marzani (ITA).</p>
    <p>Final rankings in women’s team epee included Korea (gold), China (silver), USA (bronze), Poland, France, Germany, Italy and Estonia.</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="42-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg42Anim = new TimelineMax();
        pg42Anim
          .fromTo(idOf("42-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg42Anim.stop();
        resetNumbers("42-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "EPEE GRAND PRIX KATOWICE, POLAND 2 OF 2  Korea’s Injeong Choi won the individual gold medal at the Katowice Women’s Epee World Cup, with Korea winning women’s team epee. The competition, which was held at the Katowice Academy of Physical Education, included 187 individual fencers and 19 teams.  Nelli Differt (EST), Martyna SwatowskaWenglarczyk (POL), Irina Embrich (EST) and Roberta Marzani (ITA). Final rankings in women’s team epee included Korea (gold), China (silver), USA (bronze), Poland, France, Germany, Italy and Estonia. ■  Choi faced Italy’s Alberta Santuccio in the final match of the women’s individual epee event, winning with a 15-10 score. In the semifinal round, Santuccio won against Hungary’s Anna Kun, 15-10, while Choi defeated France’s MarieFlorence Candassamy, 15-12.  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In the women’s team epee event, Korea won against China in the final match, 34-29. In the semifinal round, China defeated Poland, 4529, while Korea beat USA, 35-34. The bronze medal went to USA over Poland, 39-33. Final rankings in women’s individual epee included Injeong Choi (KOR, gold), Alberta Santuccio (ITA, silver), Anna Kun (HUN, bronze), Marie-Florence Candassamy (FRA, bronze),  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 43-title" style="top:83px;left:541px;" src="/121/en/static/_content/43-title-1.png">
      <img class="abs halfScale 43-sub" style="top:192px;left:830px;" src="/121/en/static/_content/43-sub-1.png">
      <img class="abs halfScale 43-line" style="top:191px;left:797px;" src="/121/en/static/_content/43-line-1.png">
      <img id="43-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg43Anim = new TimelineMax();
        pg43Anim
          .fromTo(cOf("43-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("43-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("43-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("43-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg43Anim.stop();
        resetNumbers("43-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  ITALY WINS DOUBLE GOLD IN PLOVDIV FOIL WORLD CUP PLOVDIV, BULGARIA 29 APRIL–01 MAY 2022",
    "mobileHtml":`
    <h2>Italy Wins Double Gold in Plovdiv Foil World Cup</h2>
      <img src="/121/en/static/_mobile/43-mobile-1.png">
      <p><strong>Plovdiv, Bulgaria</strong><br>
    29 April-01 May 2022</p>
    <p>Korea’s Injeong Choi won the individual gold medal at the Katowice Women’s Epee World 
    Cup, with Korea winning women’s team epee.</p>
    <p>Italian world champion Alessio Foconi won individual gold at the Plovdiv Men’s Foil World Cup with Italy winning the men’s team event.</p>
    <p>The competition took place at the Kolodrum Plovdiv sports facility, with 188 individual fencers and 24 teams participating. 
    </p>
    <p>Foconi faced teammate and Olympic champion Daniele Garozzo in the final match of the men’s individual foil event, winning with a 15-11 score. Garozzo won against teammate Tommaso Marini in the semifinal round, 15-6, while Foconi defeated Hungary’s Gergo Szemes, 15-4. </p>
    <p>In men’s team foil, Italy won against France in the final match, 45-28. France beat Japan in the semifinals, 45-42, while Italy defeated USA, 45-27. The bronze medal went to USA over Japan, 45-42. </p>
    <p>Final rankings for men’s individual foil included Alessio Foconi (ITA, gold), Daniele Garozzo (ITA, silver), Tommaso Marini (ITA, bronze), Gergo Szemes (HUN, bronze), Gerek Meinhardt (USA), Nick Itkin (USA), Mohamed Hamza (EGY) and Guillaume Bianchi (ITA). </p>
    <p>Final rankings for men’s team foil included Italy (gold), France (silver), USA (bronze), Japan, Korea, Poland, Hungary and Ukraine.</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="44-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg44Anim = new TimelineMax();
        pg44Anim
          .fromTo(idOf("44-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg44Anim.stop();
        resetNumbers("44-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FOIL WORLD CUP PLOVDIV, BULGARIA 2 OF 2  Marini in the semifinal round, 15-6, while Foconi defeated Hungary’s Gergo Szemes, 15-4.  Italian world champion Alessio Foconi won individual gold at the Plovdiv Men’s Foil World Cup with Italy winning the men’s team event. Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  The competition took place at the Kolodrum Plovdiv sports facility, with 188 individual fencers and 24 teams participating. Foconi faced teammate and Olympic champion Daniele Garozzo in the final match of the men’s individual foil event, winning with a 15-11 score. Garozzo won against teammate Tommaso  In men’s team foil, Italy won against France in the final match, 45-28. France beat Japan in the semifinals, 45-42, while Italy defeated USA, 45-27. The bronze medal went to USA over Japan, 45-42. Final rankings for men’s individual foil included Alessio Foconi (ITA, gold), Daniele Garozzo (ITA, silver), Tommaso Marini (ITA, bronze), Gergo Szemes (HUN, bronze), Gerek Meinhardt (USA), Nick Itkin (USA), Mohamed Hamza (EGY) and Guillaume Bianchi (ITA). Final rankings for men’s team foil included Italy (gold), France (silver), USA (bronze), Japan, Korea, Poland, Hungary and Ukraine. ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 45-title" style="top:310px;left:654px;" src="/121/en/static/_content/45-title-1.png">
      <img class="abs halfScale 45-sub" style="top:551px;left:686px;" src="/121/en/static/_content/45-sub-1.png">
      <img class="abs halfScale 45-line" style="top:549px;left:653px;" src="/121/en/static/_content/31-line-1.png">
      <img id="45-next" class="halfScale197 pointer" style="top:659px;right:-395px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-red.png">
    `,
    "script": `
      function onPageEnter() {
        pg47Anim = new TimelineMax();
        pg47Anim
          .fromTo(cOf("45-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("45-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("45-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("45-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg47Anim.stop();
        resetNumbers("45-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "SP ORT  USA’S KIEFER, TEAM ITALY WIN GOLD AT TAUBERBISCHOFSHEIM WOMEN’S FOIL WORLD CUP TAUBERBISCHOFSHEIM, GERMANY 29 APRIL–1 MAY 2022",
    "mobileHtml":`
    <h2>USA’s Kiefer, Team Italy Win Gold at Tauberbischofsheim Women’s Foil World Cup</h2>
      <img src="/121/en/static/_mobile/45-mobile-1.png">
      <p><strong>Tauberbischofsheim, Germany</strong><br>
    29 April–1 May 2022</p>
    <p>USA’s Olympic champion Lee Kiefer won gold at the Tauberbischofsheim Women’s Foil World Cup, with Italy winning women’s team foil.</p>
    <p>The competition took place at the Bundesstützpunkt Tauberbischofsheim, with 189 individual fencers and 22 teams participating. </p>
    <p>Kiefer faced France’s Anita Blaze in the final round of individual women’s foil, winning with a 15-7 score. Blaze won against Italy’s Erica Cipressa in the semifinal round, 15-13, while Kiefer defeated Japan’s Karin Miyawaki, 15-13. Of note, Kiefer beat Italian two-time world champion Arianna Errigo in the quarterfinals, 15-14, and Cipressa won against teammate and world champion Alice Volpi in the round of 16, 15-14.</p>
    <p>In women’s team foil, Italy faced France in the final match, winning with a 45-31 score. France won against Japan in the semifinal round, 45-37, while Italy defeated Korea, 45-30. The bronze medal went to Japan over Korea, 45-30. </p>
    <p>Final rankings in individual women’s foil included Lee Kiefer (USA, gold), Anita Blaze (FRA, silver), Erica Cipressa (ITA, bronze), Karin Miyawaki (JPN, bronze), Qingyuan Chen (CHN), Arianna Errigo (ITA), Jessica Zi Jia Guo (CAN) and Kelleigh Ryan (CAN). </p>
    <p>Final rankings in women’s team foil included Italy (gold), France (silver), Japan (bronze), Korea, USA, China, Poland and Canada.</p>
    <p>Tap <a href="https://fie.org/competitions" target="_blank">here</a> to view the RESULTS</p>
    <p><a href="https://www.youtube.com/c/FIEvideo" target="_blank">TAP HERE</a> to link to our FIE Youtube series</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:-30px"
          src="/121/en/static/_content/tw-red.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:257px;left:23px"
          src="/121/en/static/_content/fb-red.png">
      </a>
    
      <img id="46-next" class="halfScale197 pointer" style="top:658px;right:-430px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-med-red.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    
      <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:621px;left:-45px" src="/121/en/static/_content/yt-red.png">
      </a>
    
      <a href="https://fie.org/competitions" target="_blank">
        <img class="halfScaleC pointer halfpulse197 animatedpulse" style="top:499px;left:-8px"
        src="/121/en/static/_content/trophy-red.png">
      </a>
      `,
      "script": `
      function onPageEnter() {
        pg46Anim = new TimelineMax();
        pg46Anim
          .fromTo(idOf("46-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg46Anim.stop();
        resetNumbers("46-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FOIL WORLD CUP TAUBERBISCHOFSHEIM, GERMANY 2 OF 2  USA’s Olympic cmohampion Lee Kiefer won gold at the Tauberbischofsheim Women’s Foil World Cup, with Italy winning women’s team foil. The competition took place at the Bundesstützpunkt Tauberbischofsheim, with 189 individual fencers and 22 teams participating. Kiefer faced France’s Anita Blaze in the final round of individual women’s foil, winning with a 15-7 score. Blaze won against Italy’s Erica Cipressa in the semifinal round, 15-13, while Kiefer defeated Japan’s Karin Miyawaki, 1513. Of note, Kiefer beat Italian two-time world champion Arianna Errigo in the quarterfinals, 15-14, and Cipressa won against teammate and world champion Alice Volpi in the round of 16, 15-14.  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In women’s team foil, Italy faced France in the final match, winning with a 45-31 score. France won against Japan in the semifinal  round, 45-37, while Italy defeated Korea, 4530. The bronze medal went to Japan over Korea, 45-30. Final rankings in individual women’s foil included Lee Kiefer (USA, gold), Anita Blaze (FRA, silver), Erica Cipressa (ITA, bronze), Karin Miyawaki (JPN, bronze), Qingyuan Chen (CHN), Arianna Errigo (ITA), Jessica Zi Jia Guo (CAN) and Kelleigh Ryan (CAN). Final rankings in women’s team foil included Italy (gold), France (silver), Japan (bronze), Korea, USA, China, Poland and Canada. ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": `
    `,
    "script": `
    `,
    "mobileHtml": `
        <img src="/121/en/static/_mobile/47-mobile-1.jpg">
    `,      
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 48-title" style="top:58px;left:66px;" src="/121/en/static/_content/48-title-1.png">

      <img id="48-next" class="halfScale pointer" style="top:731px;right:-246px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-large-pink.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>

      <div class="contentLink" onclick="showOverlay('48-popup-1')" style=" bottom: 420px; right: 925px; width: 172px; height: 25px; "></div>
      <div class="contentLink" onclick="showOverlay('48-popup-4')" style=" bottom: 110px; right: 609px; width: 132px; height: 25px;"></div>
      <div class="contentLink" onclick="showOverlay('48-popup-3')" style="     bottom: 522px; right: 272px; width: 132px; height: 25px;"></div>
      <div class="contentLink" onclick="showOverlay('48-popup-2')" style="     bottom: 322px; right: 162px; width: 132px; height: 25px;"></div>

      <div id="48-popup-1" class="standardTransition contentOverlay hidden noclick">
        <img class="halfScale" src="/121/en/static/_content/48-popup-1.png" alt="">
        <div class="contentLink" style="top: 41px; left: 1059px; width: 35px; height: 35px;"
          onclick="hideOverlay('48-popup-1');"></div>
      </div>

      <div id="48-popup-4" class="standardTransition contentOverlay hidden noclick">
        <img id="48-pop-1" class="halfScale 48-popup" src="/121/en/static/_content/48-popup-4.png" alt="">
        <img id="48-pop-2" class="halfScale 48-popup" src="/121/en/static/_content/48-popup-5.png" style="opacity:0" alt="">
        <img id="48-pop-3" class="halfScale 48-popup" src="/121/en/static/_content/48-popup-6.png" style="opacity:0" alt="">
        <div class="contentLink" style="top:758px;left:611px;width:138px;height:48px;"
          onclick="togglePage48('48-pop-1', '48-popup');"></div>
        <div class="contentLink" style="top:758px;left:752px;width:138px;height:48px;"
          onclick="togglePage48('48-pop-2', '48-popup');"></div>
        <div class="contentLink" style="top:758px;left:892px;width:138px;height:48px;"
          onclick="togglePage48('48-pop-3', '48-popup');"></div>
        <div class="contentLink" style="top: 41px; left: 1059px; width: 35px; height: 35px;"
          onclick="hideOverlay('48-popup-4');"></div>
      </div>

      <div id="48-popup-3" class="standardTransition contentOverlay hidden noclick">
        <img class="halfScale" src="/121/en/static/_content/48-popup-3.png" alt="">
        <div class="contentLink" style="top: 41px; left: 1059px; width: 35px; height: 35px;"
          onclick="hideOverlay('48-popup-3');"></div>
      </div>

      <div id="48-popup-2" class="standardTransition contentOverlay hidden noclick">
        <img class="halfScale" src="/121/en/static/_content/48-popup-2.png" alt="">
        <div class="contentLink" style="top: 41px; left: 1059px; width: 35px; height: 35px;"
          onclick="hideOverlay('48-popup-2');"></div>
      </div>
    `,
    "script": `
      function onPageEnter() {
        pg48Anim = new TimelineMax();
        pg48Anim
          .fromTo(cOf("48-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(idOf("48-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1.2)
      }

      function togglePage48(show, hide) {
        var show = idOf(show)
        var hide = cOf(hide)
        TweenMax.to(hide, 0.01, {opacity: 0});
        TweenMax.to(show, 0.01, {opacity:1});
      }
    
      function onPageLeave() {
        pg48Anim.stop();
        resetNumbers("48-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE  INSIDE FENCING Doping Risk Assessment – Webinar  Fourth webinar of 2022 focused on doping and mental health  See more here.  See more here.  Webinar Focused on Parents and Guardians: A Guide to Clean Sport See more here.  FIE Educational Programmes at 2022 Cairo Fencing World Championships See more here.  W W W.FIE .ORG",
    "mobileHtml":`
    <h2>INSIDE FENCING</h2>

    <p><strong>1</strong><br>
    Fourth webinar of 2022 focused on doping and mental health - <a href="#fie-1">See more here</a>.</p>
    <p><strong>2</strong><br>
    Doping Risk Assessment – Webinar  - <a href="#fie-2">See more here</a>.</p>
    <p><strong>3</strong><br>
    Webinar Focused on Parents and Guardians: A Guide to Clean Sport  - <a href="#fie-3">See more here</a>.</p>
    <p><strong>4</strong><br>
    FIE Educational Programmes at 2022 Cairo Fencing World Championships  - <a href="#fie-4">See more here</a>.</p>

    <h4 id="fie-1">1. Fourth webinar of 2022 focused on doping and mental health</h4>
      <img src="/121/en/static/_mobile/48-mobile-1.png">

    <p>Our fourth webinar of 2022 focused on doping and mental health.</p>
    <p>The importance of mental health in sport has been brought to the public attention over the last few months with several high-profile athletes speaking out. But what is the relationship between mental health and doping? How can poor mental health lead to doping and equally, how does doping effect mental health? What strategies can an athlete use to support and improve their mental health? And most importantly, what can coaches, athlete support personnel and the entire sport system do to support the athletes’ well-being to prevent doping?</p>
    <p>We delved into this topic with Thais Cevada, PhD from the Brazilian NADO Education Team, who shared her expertise and knowledge and Geneviève Jeanson, former professional cyclist and Canadian Olympian, who shared her story of how a difficult personal situation can lead to doping. Importantly, both panellists offered solutions for us all to contribute to improving the mental health of athletes, and thus protecting them against doping.</p>
    <p>As always, we were pleased to deliver these webinars in English with simultaneous translation to four additional languages – Arabic (العربي), Spanish (español), French (français) and Russian (русский).</p>
    <p>
    Topic: Doping and Mental Health<br>
    Event date: Tuesday 26 April<br>
    Panelists: Thais Cevada, PhD, Brazilian NADO Education Team, Geneviève Jeanson, Former professional cyclist and Canadian Olympian<br>
    Moderator: Nikki Hamblin, ITA Education Team.
    </p>

    <h4 id="fie-2">2. Doping Risk Assessment – Webinar</h4>
      <img src="/121/en/static/_mobile/48-mobile-2.png">

    <p>Our fourth webinar of 2022 focused on doping and mental health.</p>
    <p>Our June monthly webinar was dedicated to Doping Risk Assessment.</p>
    <p>A risk assessment is a systematic process that involves identifying, analysing and controlling hazards and risks. In our June webinar we discussed what a risk assessment is in the context of anti-doping. How does it inform anti-doping organisations’ testing and education activities? Why is a risk assessment such an important tool for clean sport? A team of ITA experts from the Science & Medical, Testing and Education departments addressed these questions in the June edition of the ITA Monthly Webinar Series.</p>
    <p>Joining the panel discussion was Ronan Coquet, PhD (ITA Science and Medical team) and Richard Mann (ITA Testing team). Moderating the conversation was Olya Abasolo, OLY from the ITA Education department. Ronan first explained what a Risk Assessment is and how it is developed. Richard then discussed how a Risk Assessment is integrated in the test distribution strategy. Finally, Olya provided an overview of the education and prevention opportunities that a doping risk assessment presents.</p>
    <p>As always, we were pleased to deliver these webinars in English with simultaneous translation to four additional languages – Arabic (العربي), Spanish (español), French (français) and Russian (русский).
    </p>
    <p>
    Topic: Doping Risk Assessment<br>
    Event date: Thursday 23 June<br>
    Panellists: Ronan Coquet PhD, ITA Science and Medical Officer, Richard Mann, ITA Testing Manager<br>
    Moderator: Olya Abasolo OLY, ITA Education Team.
    </p>

    <h4 id="fie-3">3. Webinar Focused on Parents and Guardians: A Guide to Clean Sport</h4>
      <img src="/121/en/static/_mobile/48-mobile-3.png">

    <p>Our fifth webinar of 2022 focused on Parents and Guardians, and their role in Clean Sport.</p>
    <p>Parents and guardians of young athletes have many roles. As well as being their child’s number one fan, they are their taxi driver, nutritionist, psychologist. Alongside this, parents and guardians also have an important role in their child’s development as a clean athlete. This requires an understanding of anti-doping rules, and just as importantly, an ability to positively influence their child’s values and behaviours, which in turn can prevent doping.</p>
    <p>We invited parents, guardians, all athletes, and others who work with young athletes, to tune in as our expert panellists discuss this important topic.</p>
    <p>Joining us were Dr Lubna Sibtain, whose daughter was the first female swimmer and youngest female Olympian from Pakistan, and Jodi Brown, a former international netball player, parent, and member of Drug Free Sport New Zealand’s Education Team. They shared their experiences and provided practical tips on how parents and guardians can learn about and take active roles in clean sport.</p>
    <p>As always, we were pleased to deliver these webinars in English with simultaneous translation to four additional languages – Arabic (العربي), Spanish (español), French (français) and Russian (русский).</p>
    <p>
    Topic: Parents and Guardians: A Guide to Clean Sport<br>
    Event date: Tuesday 31 May <br>
    Panelists: Dr Lubna Sibtain, IOC Certified Sport Physician and parent of young Olympian, Jodi Brown, Drug Free Sport New Zealand and International Netball Player<br>
    Moderator: Mairi Irvine, ITA Education Team.
    </p>

    <h4 id="fie-4">4. FIE Educational Programmes at 2022 Cairo Fencing World Championships</h4>
      <img src="/121/en/static/_mobile/48-mobile-4.png">

    <p>FIE Educational programmes held at the 2022 Cairo Fencing World Championships in July benefitted athletes, coaches and officials. Two stands—Donate Your Fencing Gear! (DYFG) and Safe Sport—­were featured and available to all attendees of the competition on Level 3 of the venue.</p>
    <p><strong>Safe Sport</strong></p>
    <p>The FIE is committed to providing a safe environment for all, where athletes and all stakeholders in the global fencing “family” can develop harmoniously and are respected and protected from all types of harassment and abuse. The FIE Executive Committee appointed Dr. Lisa Huzel (CAN) from the FIE Medical Commission and Michael Stafford (RSA) from the FIE Women and Fencing Council as safeguarding officers for the Cairo Championships. They will oversee daily informational and educational activities about practicing and ensuring Safe Sport at all levels of fencing, as well as about the FIE Safeguarding Policy.</p>
    <p><strong>DYFG</strong></p>
    <p>The DYFG stand highlighted six countries—Brazil, Colombia, Guam, Haiti, Kenya and Paraguay—that are this year’s beneficiaries of the DYFG programme receiving FIE-overseen distribution of equipment donated by fencers, coaches and manufacturers to provide to fencing recipients in their regions. Equipment is checked thoroughly by a dedicated FIE SEMI delegate, Baiba Brandule, to ensure compliance with FIE safety standards.</p>
    <p>Briefly, the following is a synopsis of the recipient countries and their plans for the donations: Brazil: In the Rio de Janeiro state in the city of Niteroi, with students being received from São Concalo, fencing classes will take place utilizing the donated gear at the Nilo Peçanha High School and Raul Vidal State College, among other locations. With a primary emphasis on students, the programme also involves parents and teacher in regions where family incomes rarely exceed a minimum wage.
    Colombia: As it expands fencing throughout the country, Colombia is focusing on populated regions such as Boyacá-Colombia, where since 2017 the sport in four primary communities with donations from the FIE and the Colombian Fencing Federation. The Boyacá Fencing League has already successfully trained more than 1000 children in classes, with five more cities being added. About 250 children per facility are participating in six-month programmes in 24 classes monthly in the cities of Ramiriquí, Jenesano, Sutamarchán, Monguí and Chivatá.</p>
    <p>Guam: The Guam Community College caters to disadvantaged and lower socio-economic students, and the DYFG programme enables them to practice and hold competitions. The DYFG support aids aspiring fencers with insufficient funds and resources for equipment. Currently, they must borrow equipment from the national federation, and this programme allows them to have their own gear.</p>
    <p>Haiti: The Haitian Fencing Federation, a new FIE member, is developing programs for young athletes in parts of the country such as Jacmel. Ten coaches and managers are reaching interested students who have learned about fencing in practical exercises, and the donations enable them to take fencing further as a chosen sport. To date, 40 schoolchildren ages 8 – 15 are benefitting from the equipment.</p>
    <p>Kenya: After joining the FIE in 2019, Kenya is targeting disadvantaged youth ages 13 – 18 who show potential, enthusiasm and dedication in fencing, centered in the Eastlands of Nairobi. The project aims to help youth facing significant social challenges and nurturing competitive athletes. It also engages the National Campaign Against Drugs (NACADA), which visits the programme periodically and provides additional education and support, along with the Antidoping Agency of Kenya (ADAK).</p>
    <p>Paraguay: About 50 young fencers between the ages of 10 and 20 are training in Paraguay twice weekly for a year in Barrio Santa Ana (Cateura) and Ricardo Brugada (Community Center #1 Chacarita). While lacking equipment, the Paraguay Fencing Federation is working to train athletes to represent their country at regional, national and international events. Without equipment, they often must improvise gear to train effectively, and additional support is now coming from the city of Asunción and Club Paraguayo de Esgrima.</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": `
    <a href="mailto:service@blue-gauntletservice.com" target="_blank">
      <div class="contentLinkNone" style="bottom: 81px; right: 749px; width: 385px; height: 31px;"></div>
    </a>
    <a href="https://www.blue-gauntlet.com" target="_blank">
      <div class="contentLinkNone" style="bottom: 24px; right: 833px; width: 302px; height: 43px;"></div>
    </a>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
      <a href="https://www.blue-gauntlet.com" target="_blank">
        <img src="/121/en/static/_mobile/49-mobile-1.jpg">
      </a>
    `,      
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 50-title" style="top:521px;left:66px;" src="/121/en/static/_content/50-title-1.png">
      <img class="abs halfScale197 50-sub" style="top:665px;left:408px;" src="/121/en/static/_content/50-sub-1.png">
      <img class="abs halfScale 50-line" style="top:663px;left:380px;" src="/121/en/static/_content/50-line-1.png">
      <img id="50-next" class="halfScale pointer" style="top:659px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    `,
    "script": `
      function onPageEnter() {
        pg50Anim = new TimelineMax();
        pg50Anim
          .fromTo(cOf("50-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("50-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("50-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("50-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg50Anim.stop();
        resetNumbers("51-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDER ATION NE WS  FENCERS GATHER FOR WORLD’S LARGEST FENCING TOURNAMENT MINNEAPOLIS, MINN., USA OF 2022 2-11 JULY 2022",
    "mobileHtml":`
    <h2>Fencers Gather for World’s Largest Fencing Tournament of 2022</h2>
      <img src="/121/en/static/_mobile/50-mobile-1.png">
      <p><strong>MINNEAPOLIS, Minn., USA</strong><br>
    2-11 July 2022</p>
    <p>More than 4,400 fencers from 45 different U.S. states gathered in Minneapolis for the 2022 USA Fencing National Championships and July Challenge. </p>
    <p>The tournament, held from July 2 to 11, welcomed fencers as young as 7 and as old as 84 to the Minneapolis Convention Center. The event was so large that it took up three giant halls in the spacious venue. </p>
    <p>A total of 81 fencing strips were used for the 95 different events, including 66 events whose winners were crowned national champions.</p>
    <p>At 84, Vic Bianchini (San Diego, Calif.) was the tournament’s oldest fencer. But that didn’t stop him from earning a national championship in Vet-80 men’s sabre. It was the latest in a long string of medals for Bianchini, so what keeps him coming back year after year? “First of all, I love fencing. It's been such a gift to me”, he says. “And I keep doing it because it's it's good physical exercise and I succeeded in it. You know what they say about golf: It's that great ball that you hit straight down the fairway that keeps you coming back? Well, that's what fencing is like for me.”</p>
    <p>Twelve-year-old Devyn Anthony (Hoboken, N.J.) has a similar passion for the sport. And he, too, earned a national championship in Minneapolis. </p>
    <p>“I told my parents this morning, ‘I'm gonna go for the gold’”, he says. “I always think that I can win. Even if I lose a bout, I say, ‘I'll get them next time.’”</p>
    <p>That calm confidence paid off with a Y-12 men’s sabre national championship. “I just love fencing. I love the speed of it”, he says. “It’s just my favorite sport.”</p>
    <p>Non-championship events were open to fencers from anywhere in the world, and the competition for those July Challenge events welcomed fencers from 12 foreign countries, including Australia, Canada, Chile, China, Denmark, Germany, Hong Kong-China, South Korea, Taiwan, Ukraine, United Arab Emirates and the United Kingdom.</p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="51-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg51Anim = new TimelineMax();
        pg51Anim
          .fromTo(idOf("51-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg51Anim.stop();
        resetNumbers("51-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 3  More than 4,400 fencers from 45 different U.S. states gathered in Minneapolis for the 2022 USA Fencing National Championships and July Challenge. The tournament, held from July 2 to 11, welcomed fencers as young as 7 and as old as 84 to the Minneapolis Convention Center. The event was so large that it took up three giant halls in the spacious venue. A total of 81 fencing strips were used for the 95 different events, including 66 events whose winners were crowned national champions. At 84, Vic Bianchini (San Diego, Calif.) was the tournament’s oldest fencer. But that didn’t stop him from earning a national championship in Vet-80 men’s sabre. It was the latest in a long string of medals for Bianchini, so what keeps him coming back year after year? “First of all, I love fencing. It's been such a gift to me”, he says. “And I keep doing it because it's it's good physical exercise and I succeeded in it. You know what they say about golf: It's that  great ball that you hit straight down the fairway that keeps you coming back? Well, that's what fencing is like for me.” Twelve-year-old Devyn Anthony (Hoboken, N.J.) has a similar passion for the sport. And he, too, earned a national championship in Minneapolis."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="52-next" class="halfScale pointer" style="top:658px;right:-81px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg52Anim = new TimelineMax();
        pg52Anim
          .fromTo(idOf("52-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg52Anim.stop();
        resetNumbers("52-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 3 OF 3  “I told my parents this morning, ‘I'm gonna go for the gold’”, he says. “I always think that I can win. Even if I lose a bout, I say, ‘I'll get them next time.’”  from 12 foreign countries, including Australia, Canada, Chile, China, Denmark, Germany, Hong Kong-China, South Korea, Taiwan, Ukraine, United Arab Emirates and the United Kingdom.■  That calm confidence paid off with a Y-12 men’s sabre national championship. “I just love fencing. I love the speed of it”, he says. “It’s just my favorite sport.” Non-championship events were open to fencers from anywhere in the world, and the competition for those July Challenge events welcomed fencers  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 53-title" style="top:111px;left:714px;" src="/121/en/static/_content/53-title-1.png">
      <img class="abs halfScale 53-sub" style="top:301px;left:749px;" src="/121/en/static/_content/53-sub-1.png">
      <img class="abs halfScale 53-line" style="top:302px;left:716px;" src="/121/en/static/_content/53-line-1.png">
      <img id="53-next" class="halfScale pointer" style="top:659px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    `,
    "script": `
      function onPageEnter() {
        pg53Anim = new TimelineMax();
        pg53Anim
          .fromTo(cOf("53-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("53-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("53-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("53-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg53Anim.stop();
        resetNumbers("53-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDER ATION NE WS  PAN AMERICAN SENIOR FENCING CHAMPIONSHIPS FINISH IN PARAGUAY ASUNCIÓN, PARAGUAY 2–8 JUNE 2022",
    "mobileHtml":`
    <h2>Pan American Senior Fencing Championships Finish in Paraguay</h2>
      <img src="/121/en/static/_mobile/53-mobile-1.png">
      <p><strong>Asunción, Paraguay</strong><br>
    2–8 June 2022</p>
    <p>The 2022 Pan American Senior Fencing Championships have finished, including 12 men’s and women’s individual and team events in epee, foil and sabre.</p>
    <p>The event took place in Asunción’s Polideportivo Central del Parque Olimpico, with 303 individual fencers and 24 countries participating. USA won the medal count, including 15 overall (7 gold, 4 silver, 4 bronze), followed by Canada with 11 (2 gold, 5 silver, 4 bronze) and Venezuela with 6 (2 gold, 2 silver, 2 bronze).</p>

    <p><strong>Day 1</strong></p>
    <p>In individual men’s sabre, USA’s Daryl Homer faced teammate Eli Dershwitz in the final match, winning with a 15-11 score. In the semifinal round, Dershwitz won against Argentina’s Pascual Maria Di Tella, 15-11, while Homer defeated teammate Andrew Mackiewicz, 15-4.</p>
    <p>In individual women’s sabre, USA’s Anne-Elizabeth Stone faced Canada’s Gabriella Page in the final match, winning with a 15-11 score. In the semifinal round, Page won against teammate Madison Thurgood, 15-5, while Stone defeated Venezuela’s Shia Rodriguez, 15-7.</p>

    <p><strong>Individual Men’s Sabre (52 fencers)</strong><br>
    1. Daryl Homer (USA, gold)<br>
    2. Eli Dershwitz (USA, silver)<br>
    3. Andrew Mackiewicz (USA, bronze)<br>
    3. Pascual Maria Di Tella (ARG, bronze)<br>
    5. Fares Arfa (CAN)<br>
    6. Eliecer Romero (VEN)<br>
    7. Jose Quintero (VEN)<br>
    8. Roberto Monsalva (CHI)
    </p>

    <p><strong>Individual Women’s Sabre (47 fencers)</strong><br>
    1. Anne-Elizabeth Stone (USA, gold)<br>
    2. Gabriella Page (CAN, silver)<br>
    3. Madison Thurgood (CAN, bronze)<br>
    3. Shia Rodriguez (VEN, bronze)<br>
    5. Natalia Botello (MEX)<br>
    6. Elizabeth Tartakovsky (USA)<br>
    7. Maria Belen Perez Maurice (ARG)<br>
    8. Julieta Toledo (MEX)
    </p>

    <p><strong>Day 2</strong></p>
    <p>In men’s team sabre, USA faced Canada, winning with a 45-37 score. In the semifinal round, Canada won against Brazil, 45-24, while USA defeated Colombia, 45-39. The bronze medal went to Colombia over Brazil, 45-35.</p>
    <p>In the final match of women’s team sabre, USA faced Canada, winning with a 45-34 score. In the semifinal round, Canada won against Brazil, 45-32, while USA defeated Venezuela, 45-29. The bronze medal went to Brazil over Venezuela, 45-44.</p>

    <p><strong>Men’s Team Sabre (14 countries)</strong><br>
    1. USA (gold)<br>
    2. Canada (silver)<br>
    3. Colombia (bronze)<br>
    4. Brazil<br>
    5. Venezuela<br>
    6. Argentina<br>
    7. Mexico<br>
    8. Chile
    </p>

    <p><strong>Women’s Team Sabre (11 countries)</strong><br>
    1. USA (gold)<br>
    2. Canada (silver)<br>
    3. Brazil (bronze)<br>
    4. Venezuela<br>
    5. Mexico<br>
    6. Argentina<br>
    7. Colombia<br>
    8. Chile
    </p>

    <p><strong>Day 3</strong></p>
    <p>In individual men’s foil, USA’s Alexander Massialas faced Canada’s Maximilien Van Haaster in the final match, winning with a 15-13 score. In the semifinal round, Van Haaster won against USA’s Nick Itkin, 15-13, while Massialas defeated teammate Gerek Meinhardt, 15-14.</p>
    <p>In individual women’s foil, Canada’s Eleanor Harvey faced USA’s Olympic champion Lee Kiefer in the final match, winning with a 15-11 score. In the semifinal round, Kiefer won against teammate Jacqueline Dubrovich, 15-10, while Harvey defeated teammate Jessica Zi Jia Guo, 15-13.</p>

    <p><strong>Individual Men’s Foil (47 fencers)</strong><br>
    1. Alexander Massialas (USA, gold)<br>
    2. Maximilien Van Haaster (CAN, silver)<br>
    3. Gerek Meinhardt (USA, bronze)<br>
    3. Nick Itkin (USA, bronze)<br>
    5. Chase Emmer (USA)<br>
    6. Dante Leonel Cerquetti (ARG)<br>
    7. Blake Broszus (CAN)<br>
    8. Eli Schenkel (CAN)
    </p>

    <p><strong>Individual Women’s Foil (44 fencers)</strong><br>
    1. Eleanor Harvey (CAN, gold)<br>
    2. Lee Kiefer (USA, silver)<br>
    3. Jessica Zi Jia Guo (CAN, bronze)<br>
    3. Jacqueline Dubrovich (USA, bronze)<br>
    5. Katina Proestakis (CHI)<br>
    6. Zander Rhodes (USA)<br>
    7. Sabrina Fang (CAN)<br>
    8. Mariana Pistoia (BRA)
    </p>

    <p><strong>Day 4</strong></p>
    <p>In the final match of men’s team foil, USA faced Canada, winning with a 45-25 score. In the semifinal round, Canada won against Brazil, 45-34, while USA defeated Argentina, 45-18. The bronze medal went to Brazil over Argentina, 45-41.</p>
    <p>In the final match of women’s team foil, Canada faced USA, winning with a 45-37 score. In the semifinal round, USA won against Chile, 45-16, while Canada defeated Brazil, 45-25. The bronze medal went to Chile over Brazil, 44-43.</p>

    <p><strong>Men’s Team Foil (12 countries)</strong><br>
    USA (gold)<br>
    Canada (silver)<br>
    Brazil (bronze)<br>
    Argentina<br>
    Venezuela<br>
    Chile<br>
    Mexico<br>
    Colombia
    </p>

    <p><strong>Women’s Team Foil (10 countries)</strong><br>
    Canada (gold)<br>
    USA (silver)<br>
    Chile (bronze)<br>
    Brazil<br>
    Mexico<br>
    Colombia<br>
    Argentina<br>
    Peru
    </p>

    <p><strong>Day 5</strong></p>
    <p>In individual men’s epee, Venezuela’s Ruben Limardo Gascon faced teammate Grabiel Lugo in the final match, winning with a 10-9 score. In the semifinal round, Lugo won against Canada’s Samuel Gallagher Pelletier, 15-12, while Limardo Gascon defeated teammate Francisco Limardo, 15-11.</p>
    <p>In individual women’s epee, Argentina’s Isabel Di Tella faced USA’s Katharine Holmes in the final match, winning with a 15-12 score. In the semifinal round, Holmes won against Paraguay’s Montserrat Viveros, 15-11, while Di Tella defeated Mexico’s Sheila Liliana Tejeda, 15-9.</p>

    <p><strong>Individual Men’s Epee (58 fencers)</strong><br>
    1. Ruben Limardo Gascon (VEN, gold)<br>
    2. Grabiel Lugo (VEN, silver)<br>
    3. Francisco Limardo (VEN, bronze)<br>
    3. Samuel Gallager Pelletier (CAN, bronze)<br>
    5. Eduardo Garcia (PER)<br>
    6. Curtis McDowald (USA)<br>
    7. Athos Schwantes (BRA)<br>
    8. Dariel Carrion Arce (CUB)
    </p>

    <p><strong>Individual Women’s Epee (55 fencers)</strong><br>
    1. Isabel Di Tella (ARG, gold)<br>
    2. Katharine Holmes (USA, silver)<br>
    3. Montserrat Viveros (PAR, bronze)<br>
    3. Sheila Liliana Tejeda (MEX, bronze)<br>
    5. Leonora MacKinnon (CAN)<br>
    6. Maria Luisa Doig Calderon (PER)<br>
    7. Anna Van Brummen (USA)<br>
    8. Josefina Maria Mendez Bello (ARG)
    </p>

    <p><strong>Day 6</strong></p>
    <p>In the final match of men’s team epee, Venezuela faced Colombia, winning with a 32-31 score. In the semifinal round, Colombia won against USA, 41-40, while Venezuela defeated Argentina, 42-40. Argentina won the bronze medal against USA, 45-36.</p>
    <p>In the final match of women’s team epee, USA faced Venezuela, winning with a 35-23 score. In the semifinal round, Venezuela won against Canada, 45-41, while USA defeated Argentina, 45-25. The bronze medal went to Canada over Argentina, 43-42.</p>

    <p><strong>Men’s Team Epee (13 countries)</strong><br>
    Venezuela (gold)<br>
    Colombia (silver)<br>
    Argentina (bronze)<br>
    USA<br>
    Canada<br>
    Cuba<br>
    Brazil<br>
    Panama
    </p>

    <p><strong>Women’s Team Epee (13 countries)</strong><br>
    USA (gold)<br>
    Venezuela (silver)<br>
    Canada (bronze)<br>
    Argentina<br>
    Mexico<br>
    Brazil<br>
    Colombia<br>
    Costa Rica
    </p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="54-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg54Anim = new TimelineMax();
        pg54Anim
          .fromTo(idOf("54-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg54Anim.stop();
        resetNumbers("54-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 6  The 2022 Pan American Senior Fencing Championships have finished, including 12 men’s and women’s individual and team events in epee, foil and sabre. The event took place in Asunción’s Polideportivo Central del Parque Olimpico, with 303 individual fencers and 24 countries participating. USA won the medal count, including 15 overall (7 gold, 4 silver, 4 bronze), followed by Canada with 11 (2 gold, 5 silver, 4 bronze) and Venezuela with 6 (2 gold, 2 silver, 2 bronze).  Day 1 In individual men’s sabre, USA’s Daryl Homer faced teammate Eli Dershwitz in the final match, winning with a 15-11 score. In the semifinal round, Dershwitz won against Argentina’s Pascual Maria Di Tella, 15-11, while Homer defeated teammate Andrew Mackiewicz, 15-4. In individual women’s sabre, USA’s Anne-Elizabeth Stone faced Canada’s Gabriella Page in the final match, winning with a 15-11 score. In the semifinal  round, Page won against teammate Madison Thurgood, 15-5, while Stone defeated Venezuela’s Shia Rodriguez, 15-7. Individual Men’s Sabre (52 fencers) 1. Daryl Homer (USA, gold) 2. Eli Dershwitz (USA, silver) 3. Andrew Mackiewicz (USA, bronze) 3. Pascual Maria Di Tella (ARG, bronze) 5. Fares Arfa (CAN) 6. Eliecer Romero (VEN) 7. Jose Quintero (VEN) 8. Roberto Monsalva (CHI)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 55-title" style="top:111px;left:714px;" src="/121/en/static/_content/55-title-1.png">
      <img class="abs halfScale 55-sub" style="top:301px;left:749px;" src="/121/en/static/_content/55-sub-1.png">
      <img class="abs halfScale 55-line" style="top:302px;left:716px;" src="/121/en/static/_content/55-line-1.png">
      <img id="55-next" class="halfScale pointer" style="top:659px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    `,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="55-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg55Anim = new TimelineMax();
        pg55Anim
          .fromTo(idOf("55-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg55Anim.stop();
        resetNumbers("55-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 3 OF 6  Individual Women’s Sabre (47 fencers) 1. Anne-Elizabeth Stone (USA, gold) 2. Gabriella Page (CAN, silver) 3. Madison Thurgood (CAN, bronze) 3. Shia Rodriguez (VEN, bronze) 5. Natalia Botello (MEX) 6. Elizabeth Tartakovsky (USA) 7. Maria Belen Perez Maurice (ARG) 8. Julieta Toledo (MEX)  Day 2 In men’s team sabre, USA faced Canada, winning with a 45-37 score. In the semifinal round, Canada won against Brazil, 45-24, while USA defeated Colombia, 45-39. The bronze  medal went to Colombia over Brazil, 45-35. In the final match of women’s team sabre, USA faced Canada, winning with a 45-34 score. In the semifinal round, Canada won against Brazil, 45-32, while USA defeated Venezuela, 45-29. The bronze medal went to Brazil over Venezuela, 45-44. Men’s Team Sabre (14 countries) 1. USA (gold) 2. Canada (silver) 3. Colombia (bronze) 4. Brazil 5. Venezuela 6. Argentina 7. Mexico 8. Chile Women’s Team Sabre (11 countries) 1. USA (gold) 2. Canada (silver) 3. Brazil (bronze) 4. Venezuela 5. Mexico 6. Argentina 7. Colombia 8. Chile"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="56-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg56Anim = new TimelineMax();
        pg56Anim
          .fromTo(idOf("56-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg56Anim.stop();
        resetNumbers("56-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "6. Dante Leonel Cerquetti (ARG) 7. Blake Broszus (CAN) 8. Eli Schenkel (CAN)  FIE & NATIONAL FEDERATION NEWS 4 OF 6  Day 3 In individual men’s foil, USA’s Alexander Massialas faced Canada’s Maximilien Van Haaster in the final match, winning with a 15-13 score. In the semifinal round, Van Haaster won against USA’s Nick Itkin, 15-13, while Massialas defeated teammate Gerek Meinhardt, 15-14. In individual women’s foil, Canada’s Eleanor Harvey faced USA’s Olympic champion Lee Kiefer in the final match, winning with a 1511 score. In the semifinal round, Kiefer won against teammate Jacqueline Dubrovich, 1510, while Harvey defeated teammate Jessica Zi Jia Guo, 15-13. Individual Men’s Foil (47 fencers) 1. Alexander Massialas (USA, gold) 2. Maximilien Van Haaster (CAN, silver) 3. Gerek Meinhardt (USA, bronze) 3. Nick Itkin (USA, bronze) 5. Chase Emmer (USA)  Individual Women’s Foil (44 fencers) 1. Eleanor Harvey (CAN, gold) 2. Lee Kiefer (USA, silver) 3. Jessica Zi Jia Guo (CAN, bronze) 3. Jacqueline Dubrovich (USA, bronze) 5. Katina Proestakis (CHI) 6. Zander Rhodes (USA) 7. Sabrina Fang (CAN) 8. Mariana Pistoia (BRA)  Day 4 In the final match of men’s team foil, USA faced Canada, winning with a 45-25 score. In the semifinal round, Canada won against Brazil, 45-34, while USA defeated Argentina, 45-18. The bronze medal went to Brazil over Argentina, 45-41. In the final match of women’s team foil, Canada faced USA, winning with a 45-37 score. In the semifinal round, USA won against Chile, 4516, while Canada defeated Brazil, 45-25. The bronze medal went to Chile over Brazil, 44-43."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="57-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg57Anim = new TimelineMax();
        pg57Anim
          .fromTo(idOf("57-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg57Anim.stop();
        resetNumbers("57-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 5 OF 6  Men’s Team Foil (12 countries) USA (gold) Canada (silver) Brazil (bronze) Argentina Venezuela Chile Mexico Colombia Women’s Team Foil (10 countries) Canada (gold) USA (silver) Chile (bronze) Brazil Mexico Colombia Argentina Peru  Day 5 In individual men’s epee, Venezuela’s Ruben Limardo Gascon faced teammate Grabiel Lugo in the final match, winning with a 10-9 score. In the semifinal round, Lugo won against  Canada’s Samuel Gallagher Pelletier, 15-12, while Limardo Gascon defeated teammate Francisco Limardo, 15-11. In individual women’s epee, Argentina’s Isabel Di Tella faced USA’s Katharine Holmes in the final match, winning with a 15-12 score. In the semifinal round, Holmes won against Paraguay’s Montserrat Viveros, 15-11, while Di Tella defeated Mexico’s Sheila Liliana Tejeda, 15-9. Individual Men’s Epee (58 fencers) 1. Ruben Limardo Gascon (VEN, gold) 2. Grabiel Lugo (VEN, silver) 3. Francisco Limardo (VEN, bronze) 3. Samuel Gallager Pelletier (CAN, bronze) 5. Eduardo Garcia (PER) 6. Curtis McDowald (USA) 7. Athos Schwantes (BRA) 8. Dariel Carrion Arce (CUB)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="58-next" class="halfScale pointer" style="top:658px;right:-81px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg58Anim = new TimelineMax();
        pg58Anim
          .fromTo(idOf("58-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg58Anim.stop();
        resetNumbers("58-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 6 OF 6  Individual Women’s Epee (55 fencers) 1. Isabel Di Tella (ARG, gold) 2. Katharine Holmes (USA, silver) 3. Montserrat Viveros (PAR, bronze) 3. Sheila Liliana Tejeda (MEX, bronze) 5. Leonora MacKinnon (CAN) 6. Maria Luisa Doig Calderon (PER) 7. Anna Van Brummen (USA) 8. Josefina Maria Mendez Bello (ARG)  Day 6 In the final match of men’s team epee, Venezuela faced Colombia, winning with a 3231 score. In the semifinal round, Colombia won against USA, 41-40, while Venezuela defeated Argentina, 42-40. Argentina won the bronze medal against USA, 45-36. In the final match of women’s team epee, USA faced Venezuela, winning with a 35-23 score.  In the semifinal round, Venezuela won against Canada, 45-41, while USA defeated Argentina, 45-25. The bronze medal went to Canada over Argentina, 43-42. Men’s Team Epee (13 countries) Venezuela (gold) Colombia (silver) Argentina (bronze) USA Canada Cuba Brazil Panama Women’s Team Epee (13 countries) USA (gold) Venezuela (silver) Canada (bronze) Argentina Mexico Brazil Colombia Costa Rica ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": `
      <a href="https://www.fencewithfun.com" target="_blank">
        <div class="contentLinkNone" style="bottom: 263px; right: 30px; width: 25px; height: 154px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
      <a href="https://www.fencewithfun.com" target="_blank">
        <img src="/121/en/static/_mobile/59-mobile-1.jpg">
      </a>
    `,      
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale197 60-title" style="top:101px;left:83px;" src="/121/en/static/_content/60-title-1.png">
      <img class="abs halfScale197 60-sub" style="top:254px;left:114px;" src="/121/en/static/_content/60-sub-1.png">
      <img class="abs halfScale197 60-line" style="top:252px;left:81px;" src="/121/en/static/_content/60-line-1.png">
      <img id="60-next" class="halfScale pointer" style="top:659px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    `,
    "script": `
      function onPageEnter() {
        pg60Anim = new TimelineMax();
        pg60Anim
          .fromTo(cOf("60-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("60-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("60-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("60-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg60Anim.stop();
        resetNumbers("60-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDER ATION NE WS  ASIAN SENIOR FENCING CHAMPIONSHIPS FINISH IN SEOUL SEOUL, KOREA 10–15 JUNE 2022",
    "mobileHtml":`
    <h2>Asian Senior Fencing Championships Finish in Seoul</h2>
      <img src="/121/en/static/_mobile/60-mobile-1.png">
      <p><strong>Seoul, Korea</strong><br>
    10–15 June 2022</p>
    <p>The 2022 Asian Senior Fencing Championships have finished, including 12 men’s and women’s individual and team events in epee, foil and sabre.</p>
    <p>The event took place at Seoul’s SK Handball Gym, with 297 individual fencers and 27 countries participating. Korea won the medal count, including 12 overall (6 gold, 3 silver, 3 bronze), followed by Japan with 12 (3 gold, 4 silver, 5 bronze) and China (1 gold, 3 silver, 5 bronze).</p>

    <p><strong>Day 1</strong></p>
    <p>In individual men’s sabre, Korea’s Bongil Gu faced teammate and world champion Junghwan Kim in the final match, winning with a 15-11 score. In the semifinal round, Kim won against teammate and world champion Sanguk Oh, 15-11, while Gu defeated Kazakhstan’s Artyom Sarkissyan, 15-10.</p>
    <p>In women’s individual epee, Hong Kong, China’s Man Wai Vivian Kong faced Korea’s Injeong Choi in the final match, winning with a 12-11 score. In the semifinal round, Choi won against Japan’s Nozomi Sato, 12-11, while Kong defeated teammate Wai Ling Chan, 15-7.</p>

    <p><strong>Individual Men’s Sabre (58 fencers)</strong><br>
    1. Bongil Gu (KOR, gold)<br>
2. Junghwan Kim (KOR, silver)<br>
3. Artyom Sarkissyan (KAZ, bronze)<br>
3. Sanguk Oh (KOR, bronze)<br>
5. Mohammad Fotouhi (IRI)<br>
6. Kaito Streets (JPN)<br>
7. Mao Kokubo (JPN)<br>
8. Nima Zahedi (IRI)
    </p>

    <p><strong>Individual Women’s Epee (44 fencers)</strong><br>
    1. Man Wai Vivian Kong (HKG, gold)<br>
2. Injeong Choi (KOR, silver)<br>
3. Wai Ling Chan (HKG, bronze)<br>
3. Nozomi Sato (JPN, bronze)<br>
5. Sera Song (KOR)<br>
6. Young Mi Kang (KOR)<br>
7. Miho Yoshimura (JPN)<br>
8. Sofiya Nikolaichuk (KAZ)
    </p>

    <p><strong>Day 2</strong></p>
    <p>In individual men’s epee, Japan’s Koki Kano faced teammate Akira Komata in the final match, winning with a 15-10 score. In the semifinal round, Komata won against Korean Olympic champion Sangyoung Park, 14-13, while Kano defeated China’s Minghao Lan, 15-11.</p>
    <p>In individual women’s foil, China’s Yue Shi faced teammate Qingyuan Chen in the final match, winning with a 15-9 score. In the semifinal round, Chen won against Japan’s Sera Azuma, 15-11, while Shi defeated Japan’s Yuko Ueno, 15-11.</p>

    <p><strong>Individual Men’s Epee (65 fencers)</strong><br>
    1. Koki Kano (JPN, gold)<br>
2. Akira Komata (JPN, silver)<br>
3. Minghao Lan (CHN, bronze)<br>
3. Sangyoung Park (KOR, bronze)<br>
5. Elmir Alimzhanov (KAZ)<br>
6. Myeongki Kim (KOR)<br>
7. Roman Aleksandrov (UZB)<br>
8. Vadim Sharlaimov (KAZ)
    </p>

    <p><strong>Individual Women’s Foil (42 fencers)</strong><br>
    1. Yue Shi (CHN, gold)<br>
2. Qingyuan Chen (CHN, silver)<br>
3. Yuka Ueno (JPN, bronze)<br>
3. Sera Azuma (JPN, bronze)<br>
5. Amita Berthier (SGP)<br>
6. Yuzuha Takeyama (JPN)<br>
7. Hiu Wai Valerie Cheng (HKG)<br>
8. Yuanting Cai (CHN)
    </p>

    <p><strong>Day 3</strong></p>
    <p>In individual men’s foil, Hong Kong, China’s Olympic champion Ka Long Cheung faced China’s Ziwei Mo in the final match, winning with a 15-6 score. In the semifinal round, Mo won against Hong Kong, China’s Chun Yin Ryan Choi, 15-14, while Cheung defeated China’s Bin Wu, 15-13.</p>
    <p>In individual women’s sabre, Korea’s Sooyeon Choi faced Japan’s Misaki Emura in the final match, winning with a 15-9 score. In the semifinal round, Emura won against China’s Ying Fu, 15-10, while Choi defeated China’s Hengyu Yang, 15-12.</p>

    <p><strong>Individual Men’s Foil (50 fencers)</strong><br>
    1. Ka Long Cheung (HKG, gold)<br>
2. Ziwei Mo (CHN, silver)<br>
3. Bin Wu (CHN, bronze)<br>
3. Chun Yin Ryan Choi (HKG, bronze)<br>
5. Takahiro Shikine (JPN)<br>
6. Samuel Elijah Robson (SGP)<br>
7. Jie Xu (CHN)<br>
8. Kyosuke Matsuyama (JPN)
    </p>

    <p><strong>Individual Women’s Sabre (38 fencers)</strong><br>
    1. Sooyeon Choi (KOR, gold)<br>
2. Misaki Emura (JPN, silver)<br>
3. Hengyu Yang (CHN, bronze)<br>
3. Ying Fu (CHN, bronze)<br>
5. Jisu Yoon (KOR)<br>
6. Seri Ozaki (JPN)<br>
7. Kesi Lin (CHN)<br>
8. Wing Kiu Chu (HKG)
    </p>

    <p><strong>Day 4</strong></p>
    <p>In the final match of men’s team sabre, Korea faced Japan, winning with a 45-33 score. In the semifinal round, Japan won against Iran, 45-44, while Korea defeated Hong Kong, China, 45-31. The bronze medal went to Iran over Hong Kong, China, 45-33.</p>
    <p>In the final match of women’s team epee, Korea faced Hong Kong, China, winning with a 39-27 score. In the semifinal round, Hong Kong, China won against China, 40-30, while Korea defeated Japan, 45-35. The bronze medal went to Japan over China, 45-38.</p>

    <p><strong>Men’s Team Sabre (14 countries)</strong><br>
    1. Korea (gold)<br>
2. Japan (silver)<br>
3. Iran (bronze)<br>
4. Hong Kong, China<br>
5. China<br>
6. Kazakhstan<br>
7. Kuwait<br>
8. Thailand
    </p>

    <p><strong>Women’s Team Epee (11 countries)</strong><br>
    1. Korea (gold)<br>
2. Hong Kong, China (silver)<br>
3. Japan (bronze)<br>
4. China<br>
5. Singapore<br>
6. Thailand<br>
7. Chinese Taipei<br>
8. Indonesia
    </p>

    <p><strong>Day 5</strong></p>
    <p>In the final match of men’s team epee, Korea faced Uzbekistan, winning with a 38-35 score. In the semifinal round, Uzbekistan won against Japan, 36-35, while Korea defeated China, 29-25. The bronze medal went to Japan over China, 42-37.</p>
    <p>In the final match of women’s team foil, Japan faced China, winning with a 45-33 score. In the semifinal round, China won against Korea, 43-29, while Japan defeated Singapore, 45-31. The bronze medal went to Korea over Singapore, 44-35.</p>

    <p><strong>Men’s Team Epee (17 countries)</strong><br>
    1. Korea (gold)<br>
2. Uzbekistan (silver)<br>
3. Japan (bronze)<br>
4. China<br>
5. Kazakhstan<br>
6. Hong Kong, China<br>
7. Kyrgyzstan<br>
8. Australia
    </p>

    <p><strong>Women’s Team Foil (10 countries)</strong><br>
    1. Japan (gold)<br>
2. China (silver)<br>
3. Korea (bronze)<br>
4. Singapore<br>
5. Hong Kong, China<br>
6. Australia<br>
7. Philippinesbr>
8. Chinese Taipei
    </p>

    <p><strong>Day 6</strong></p>
    <p>In the final match of men’s team foil, Japan faced Korea, winning with a 45-33 score. In the semifinal round, Korea won against Hong Kong, China, 45-42, while Japan defeated Chinese Taipei, 45-26. The bronze medal went to Hong Kong, China over Chinese Taipei, 45-30.</p>
    <p>In the final match of women’s team sabre, Korea faced Japan, winning with a 45-39 score. In the semifinal round, Japan won against China, 45-42, while Korea defeated Kazakhstan, 45-34. The bronze medal went to China over Kazakhstan, 45-35.</p>

    <p><strong>Men’s Team Foil (12 countries)</strong><br>
    1. Japan (gold)<br>
2. Korea (silver)<br>
3. Hong Kong, China (bronze)<br>
4. Chinese Taipei<br>
5. China<br>
6. Singapore<br>
7. Australia<br>
8. Kuwait
    </p>

    <p><strong>Women’s Team Sabre (9 countries)</strong><br>
    1. Korea (gold)<br>
2. Japan (silver)<br>
3. China (bronze)<br>
4. Kazakhstan<br>
5. Indonesia<br>
6. Singapore<br>
7. Hong Kong, China<br>
8. Thailand
    </p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="61-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg63Anim = new TimelineMax();
        pg63Anim
          .fromTo(idOf("61-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg63Anim.stop();
        resetNumbers("61-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 7  The 2022 Asian Senior Fencing Championships have finished, including 12 men’s and women’s individual and team events in epee, foil and sabre. The event took place at Seoul’s SK Handball Gym, with 297 individual fencers and 27 countries participating. Korea won the medal count, including 12 overall (6 gold, 3 silver, 3 bronze), followed by Japan with 12 (3 gold, 4 silver, 5 bronze) and China (1 gold, 3 silver, 5 bronze).  Day 1 In individual men’s sabre, Korea’s Bongil Gu faced teammate and world champion Junghwan Kim in the final match, winning with a 15-11 score. In the semifinal round, Kim won against teammate and world champion Sanguk Oh, 15-11, while Gu defeated Kazakhstan’s Artyom Sarkissyan, 15-10. In women’s individual epee, Hong Kong, China’s Man Wai Vivian Kong faced Korea’s Injeong Choi in the final match, winning with a 12-11 score. In the semifinal round, Choi won against Japan’s Nozomi Sato, 12-11, while Kong defeated teammate Wai Ling Chan, 15-7. Individual Men’s Sabre (58 fencers) 1. Bongil Gu (KOR, gold) 2. Junghwan Kim (KOR, silver) 3. Artyom Sarkissyan (KAZ, bronze) 3. Sanguk Oh (KOR, bronze) 5. Mohammad Fotouhi (IRI) 6. Kaito Streets (JPN) 7. Mao Kokubo (JPN) 8. Nima Zahedi (IRI)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="62-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg62Anim = new TimelineMax();
        pg62Anim
          .fromTo(idOf("62-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg62Anim.stop();
        resetNumbers("62-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "In individual women’s foil, China’s Yue Shi faced teammate Qingyuan Chen in the final match, winning with a 15-9 score. In the semifinal round, Chen won against Japan’s Sera Azuma, 15-11, while Shi defeated Japan’s Yuko Ueno, 15-11.  FIE & NATIONAL FEDERATION NEWS 3 OF 7  Individual Women’s Epee (44 fencers) 1. Man Wai Vivian Kong (HKG, gold) 2. Injeong Choi (KOR, silver) 3. Wai Ling Chan (HKG, bronze) 3. Nozomi Sato (JPN, bronze) 5. Sera Song (KOR) 6. Young Mi Kang (KOR) 7. Miho Yoshimura (JPN) 8. Sofiya Nikolaichuk (KAZ)  Day 2 In individual men’s epee, Japan’s Koki Kano faced teammate Akira Komata in the final match, winning with a 15-10 score. In the semifinal round, Komata won against Korean Olympic champion Sangyoung Park, 14-13, while Kano defeated China’s Minghao Lan, 15-11.  Individual Men’s Epee (65 fencers) 1. Koki Kano (JPN, gold) 2. Akira Komata (JPN, silver) 3. Minghao Lan (CHN, bronze) 3. Sangyoung Park (KOR, bronze) 5. Elmir Alimzhanov (KAZ) 6. Myeongki Kim (KOR) 7. Roman Aleksandrov (UZB) 8. Vadim Sharlaimov (KAZ) Individual Women’s Foil (42 fencers) 1. Yue Shi (CHN, gold) 2. Qingyuan Chen (CHN, silver) 3. Yuka Ueno (JPN, bronze) 3. Sera Azuma (JPN, bronze) 5. Amita Berthier (SGP) 6. Yuzuha Takeyama (JPN) 7. Hiu Wai Valerie Cheng (HKG) 8. Yuanting Cai (CHN)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="63-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg63Anim = new TimelineMax();
        pg63Anim
          .fromTo(idOf("63-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg63Anim.stop();
        resetNumbers("63-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "Individual Men’s Foil (50 fencers) 1. Ka Long Cheung (HKG, gold) 2. Ziwei Mo (CHN, silver) 3. Bin Wu (CHN, bronze) 3. Chun Yin Ryan Choi (HKG, bronze) 5. Takahiro Shikine (JPN) 6. Samuel Elijah Robson (SGP) 7. Jie Xu (CHN) 8. Kyosuke Matsuyama (JPN)  FIE & NATIONAL FEDERATION NEWS 4 OF 7  Day 3 In individual men’s foil, Hong Kong, China’s Olympic champion Ka Long Cheung faced China’s Ziwei Mo in the final match, winning with a 15-6 score. In the semifinal round, Mo won against Hong Kong, China’s Chun Yin Ryan Choi, 15-14, while Cheung defeated China’s Bin Wu, 15-13. In individual women’s sabre, Korea’s Sooyeon Choi faced Japan’s Misaki Emura in the final match, winning with a 15-9 score. In the semifinal round, Emura won against China’s Ying Fu, 15-10, while Choi defeated China’s Hengyu Yang, 15-12.  Individual Women’s Sabre (38 fencers) 1. Sooyeon Choi (KOR, gold) 2. Misaki Emura (JPN, silver) 3. Hengyu Yang (CHN, bronze) 3. Ying Fu (CHN, bronze) 5. Jisu Yoon (KOR) 6. Seri Ozaki (JPN) 7. Kesi Lin (CHN) 8. Wing Kiu Chu (HKG) In the final match of men’s team sabre, Korea faced Japan, winning with a 45-33 score. In the semifinal round, Japan won against Iran, 45-44, while Korea defeated Hong Kong, China, 45-31. The bronze medal went to Iran over Hong Kong, China, 45-33."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="64-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg64Anim = new TimelineMax();
        pg64Anim
          .fromTo(idOf("64-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg64Anim.stop();
        resetNumbers("64-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 5 OF 7  Day 4 In the final match of women’s team epee, Korea faced Hong Kong, China, winning with a 39-27 score. In the semifinal round, Hong Kong, China won against China, 40-30, while Korea defeated Japan, 45-35. The bronze medal went to Japan over China, 45-38. Men’s Team Sabre (14 countries) 1. Korea (gold) 2. Japan (silver) 3. Iran (bronze) 4. Hong Kong, China 5. China 6. Kazakhstan 7. Kuwait 8. Thailand Women’s Team Epee (11 countries) 1. Korea (gold) 2. Hong Kong, China (silver) 3. Japan (bronze) 4. China 5. Singapore 6. Thailand 7. Chinese Taipei 8. Indonesia  Day 5 In the final match of men’s team epee, Korea faced Uzbekistan, winning with a 38-35 score. In the semifinal round, Uzbekistan won against Japan, 36-35, while Korea defeated China, 29-25. The bronze medal went to Japan over China, 42-37. In the final match of women’s team foil, Japan faced China, winning with a 45-33 score. In the semifinal round, China won against Korea, 43-29, while Japan defeated Singapore, 45-31. The bronze medal went to Korea over Singapore, 44-35. Men’s Team Epee (17 countries) 1. Korea (gold) 2. Uzbekistan (silver) 3. Japan (bronze)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="65-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg65Anim = new TimelineMax();
        pg65Anim
          .fromTo(idOf("65-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg65Anim.stop();
        resetNumbers("65-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 6 OF 7  4. China 5. Kazakhstan 6. Hong Kong, China 7. Kyrgyzstan 8. Australia Women’s Team Foil (10 countries) 1. Japan (gold) 2. China (silver) 3. Korea (bronze) 4. Singapore 5. Hong Kong, China 6. Australia 7. Philippines 8. Chinese Taipei  Day 6 In the final match of men’s team foil, Japan faced Korea, winning with a 45-33 score. In the semifinal round, Korea won against Hong Kong, China, 45-42, while Japan defeated Chinese Taipei, 45-26. The bronze medal went to Hong Kong, China over Chinese Taipei, 45-30. In the final match of women’s team sabre, Korea faced Japan, winning with a 45-39 score. In"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="66-next" class="halfScale pointer" style="top:658px;right:-81px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg66Anim = new TimelineMax();
        pg66Anim
          .fromTo(idOf("66-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg66Anim.stop();
        resetNumbers("66-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 7 OF 7  the semifinal round, Japan won against China, 45-42, while Korea defeated Kazakhstan, 45-34. The bronze medal went to China over Kazakhstan, 45-35. Men’s Team Foil (12 countries) 1. Japan (gold) 2. Korea (silver) 3. Hong Kong, China (bronze) 4. Chinese Taipei 5. China 6. Singapore  7. Australia 8. Kuwait Women’s Team Sabre (9 countries) 1. Korea (gold) 2. Japan (silver) 3. China (bronze) 4. Kazakhstan 5. Indonesia 6. Singapore 7. Hong Kong, China 8. Thailand ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 67-title" style="top:100px;left:66px;" src="/121/en/static/_content/67-title-1.png">
      <img class="abs halfScale 67-sub" style="top:255px;left:100px;" src="/121/en/static/_content/67-sub-1.png">
      <img class="abs halfScale 67-line" style="top:253px;left:67px;" src="/121/en/static/_content/67-line-1.png">
      <img id="67-next" class="halfScale pointer" style="top:659px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    `,
    "script": `
      function onPageEnter() {
        pg67Anim = new TimelineMax();
        pg67Anim
          .fromTo(cOf("67-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("67-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("67-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(idOf("67-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
    
      function onPageLeave() {
        pg67Anim.stop();
        resetNumbers("67-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDER ATION NE WS  AFRICAN SENIOR FENCING CHAMPIONSHIPS FINISH IN CASABLANCA CASABLANCA, MOROCCO 15–19 JUNE 2022",
    "mobileHtml":`
    <h2>African Senior Fencing Championships Finish in Casablanca</h2>
      <img src="/121/en/static/_mobile/67-mobile-1.png">
      <p><strong>Casablanca, Morocco</strong><br>
    15-19 June 2022</p>
    <p>The 2022 African Senior Fencing Championships have finished, including 12 men’s and women’s individual and team events in epee, foil and sabre.</p>
    <p>The event took place at Casablanca’s Salle Couverte du Complexe Sportif Mohamed V, with 143 individual fencers and 18 countries participating. Egypt won the medal count, including 21 overall (8 gold, 6 silver, 7 bronze), followed by Algeria with 8 (2 gold, 2 silver, 4 bronze) and Tunisia with 5 (2 gold, 1 silver, 2 bronze).</p>

    <p><strong>Day 1</strong></p>
    <p>In individual men’s epee, Egypt’s Mohamed Elsayed faced teammate Ahmad Elsokkary in the final match, winning with a 13-9 score. In the semifinal round, Elsokkary won against South Africa’s Harry Saner, 15-12, while Elsayed defeated Côte d'Ivoire's Bedi Paul Alex Beugre, 15-10.</p>
    <p>In individual women’s foil, Egypt’s Nora Mohamed faced Morocco’s Youssra Zakarani in the final match, winning with a 15-9 score. In the semifinal round, Zakarani won against Egypt’s Yara Elsharkawy, 15-9, while Mohamed defeated teammate Noha Hany, 15-9.</p>

    <p><strong>Individual Men’s Epee (31 fencers)</strong><br>
    1. Mohamed Elsayed (EGY, gold)<br>
2. Ahmad Elsokkary (EGY, silver)<br>
3. Bedi Paul Alex Beugre (CIV, bronze)<br>
3. Harry Saner (RSA, bronze)<br>
5. Mohamed Yasseen (EGY)<br>
6. Pavel Tychler (RSA)<br>
7. Sergey Losevskiy (RSA)<br>
8. Raphael Jacques Hoareau-Berkani (ALG)
    </p>

    <p><strong>Individual Women’s Foil (15 fencers)</strong><br>
    1. Nora Mohamed (EGY, gold)<br>
2. Youssra Zakarini (MAR, silver)<br>
3. Yara Elsharkawy (EGY, bronze)<br>
3. Noha Hany (EGY, bronze)<br>
5. Meriem Mebarki (ALG)<br>
6. Chaima Nihal Guemmar (ALG)<br>
7. Nourane B’Chir (TUN)<br>
8. Mariam Elzoheiry (EGY)
    </p>

    <p><strong>Day 2</strong></p>
    <p>In individual men’s sabre, Tunisia’s Fares Ferjani faced Egypt’s Medhat Moataz in the final match, winning with a 15-14 score. In the semifinal round, Moataz won against his teammate, Mohamed Amer, 15-14, while Ferjani defeated his teammate, Ahmed Ferjani, 15-14.</p>
    <p>In individual women’s epee, Egypt’s Nardin Ehab faced her teammate, Shirwit Gaber, in the final match, winning with a 15-11 score. In the semifinal round, Gaber won against her teammate, Aya Hussain, 15-10, while Ehab defeated Senegal’s Ndeye Binta Diongue, 15-6.</p>

    <p><strong>Individual Men’s Sabre (30 fencers)</strong><br>
    1. Fares Ferjani (TUN, gold)<br>
2. Medhat Moataz (EGY, silver)<br>
3. Mohamed Amer (EGY, bronze)<br>
3. Ahmed Ferjani (TUN, bronze)<br>
5. Adham Moataz (EGY)<br>
6. Ziad Elsissy (EGY)<br>
7. Amenallah Hmissi (TUN)<br>
8. Evann Jean Abba Girault (NIG)
    </p>

    <p><strong>Individual Women’s Epee (24 fencers)</strong><br>
    1. Nardin Ehab (EGY, gold)<br>
2. Shirwit Gaber (EGY, silver)<br>
3. Ndeye Binta Diongue (SEN, bronze)<br>
3. Aya Hussein (EGY, bronze)<br>
5. Camilia El Kord (MAR)<br>
6. Chloe Bousfiha (MAR)<br>
6. Aphiwe Tuku (RSA)<br>
8. Aminata Sabaly (SEN)
    </p>

    <p><strong>Day 3</strong></p>
    <p>In individual men’s foil, Egypt’s Alaaeldin Abouelkassem faced teammate Mohamed Hamza in the final match, winning with a 15-14 score. In the semifinal round, Hamza won against Algeria’s Youcef Madi, 15-7, while Abouelkassem defeated teammate Mohamed Hassan, 15-11.</p>
    <p>In individual women’s sabre, Algeria’s Zohra Nora Kehli faced Egypt’s Nada Hafez in the final match, winning with a 15-10 score. In the semifinal round, Hafez won against Algeria’s Saoussen Boudiaf, 15-14, while Kehli defeated Egypt’s Mariam Deghiedy, 15-8.</p>

    <p><strong>Individual Men’s Foil (23 fencers)</strong><br>
    1. Alaaeldin Abouelkassem (EGY, gold)<br>
2. Mohamed Hamza (EGY, silver)<br>
3. Mohamed Hassan (EGY, bronze)<br>
3. Youcef Madi (ALG, bronze)<br>
5. Jeremy Fafa Keryhuel (CIV)<br>
6. Mohamed Aziz Metoui (TUN)<br>
7. Mohamed Essam (EGY)<br>
8. Victor Alvares De Oliveira (CPV)
    </p>

    <p><strong>Individual Women’s Sabre (20 fencers)</strong><br>
    1. Zohra Nora Kehli (ALG, gold)<br>
2. Nada Hafez (EGY, silver)<br>
3. Mariam Deghiedy (EGY, bronze)<br>
3. Saoussen Boudiaf (ALG, bronze)<br>
5. Yasmine Daghfous (TUN)<br>
6. Abik Boungab (ALG)<br>
7. Manal Saraa (MAR)<br>
8. Rania Ferjani (TUN)
    </p>

    <p><strong>Day 4</strong></p>
    <p>In men’s team foil, Egypt faced Algeria, winning with a 45-20 score in the final match. In the semifinal round, Algeria won against Tunisia, 45-32, while Egypt defeated Cote D’Ivoire, 45-11. The bronze medal went to Tunisia over Cote D’Ivoire, 45-42.</p>
    <p>In women’s team sabre, Algeria faced Tunisia, winning with a 45-27 score in the final match. In the semifinal round, Tunisia won against Morocco, 45-24, while Algeria defeated Egypt, 45-41. The bronze medal went to Egypt over Morocco, 45-24.</p>
    <p>In women’s team epee, Egypt faced Morocco, winning with a 45-30 score in the final match. In the semifinal round, Morocco won against Senegal, 45-41, while Egypt defeated Algeria, 45-35. The bronze medal went to Algeria over Senegal, 45-43.</p>

    <p><strong>Men’s Team Foil (6 countries)</strong><br>
    1. Egypt (gold)<br>
2. Algeria (silver)<br>
3. Tunisia (bronze)<br>
4. Cote D’Ivoire<br>
5. Ghana<br>
6. Morocco
    </p>

    <p><strong>Women’s Team Sabre (6 countries)</strong><br>
    1. Algeria (gold)<br>
2. Tunisia (silver)<br>
3. Egypt (bronze)<br>
4. Morocco<br>
5. Cote D’Ivoire<br>
5. Senegal
    </p>

    <p><strong>Women’s Team Epee (4 countries)</strong><br>
    1. Egypt (gold)<br>
2. Morocco (silver)<br>
3. Algeria (bronze)<br>
4. Senegal
    </p>

    <p><strong>Day 5</strong></p>
    <p>In men’s team epee, Egypt faced Morocco, winning with a 45-34 score in the final match. In the semifinal round, Morocco won against Senegal, 45-34, while Egypt defeated South Africa, 45-33. The bronze medal went to South Africa over Senegal, 45-33.</p>
    <p>In men’s team sabre, Tunisia faced Egypt, winning with a 45-42 score in the final match. In the semifinal round, Egypt won against Mali, 45-18, while Tunisia defeated Algeria, 45-25. The bronze medal went to Algeria over Mali, 45-39.</p>
    <p>In women’s team foil, Egypt faced Algeria, winning with a 45-23 score in the final match. In the semifinal round, Algeria won against Morocco, 45-23, while Egypt defeated Cote D’Ivoire, 45-6. The bronze medal went to Morocco over Cote D’Ivoire, 45-22.</p>

    <p><strong>Men’s Team Epee (9 countries)</strong><br>
    1. Egypt (gold)<br>
2. Morocco (silver)<br>
3. South Africa (bronze)<br>
4. Senegal<br>
5. Algeria<br>
6. Tunisia<br>
7. Libya<br>
8. Cote D’Ivoire
    </p>

    <p><strong>Men’s Team Sabre (6 countries)</strong><br>
    1. Tunisia (gold)<br>
2. Egypt (silver)<br>
3. Algeria (bronze)<br>
4. Mali<br>
5. Senegal<br>
6. Cote D’Ivoire<br>
6. Morocco
    </p>

    <p><strong>Women’s Team Foil (4 countries)</strong><br>
    1. Egypt (gold)<br>
2. Algeria (silver)<br>
3. Morocco (bronze)<br>
4. Cote D’Ivoire
    </p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="68-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg68Anim = new TimelineMax();
        pg68Anim
          .fromTo(idOf("68-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg68Anim.stop();
        resetNumbers("68-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 6  The 2022 African Senior Fencing Championships have finished, including 12 men’s and women’s individual and team events in epee, foil and sabre. The event took place at Casablanca’s Salle Couverte du Complexe Sportif Mohamed V, with 143 individual fencers and 18 countries participating. Egypt won the medal count, including 21 overall (8 gold, 6 silver, 7 bronze), followed by Algeria with 8 (2 gold, 2 silver, 4 bronze) and Tunisia with 5 (2 gold, 1 silver, 2 bronze).  Day 1 In individual men’s epee, Egypt’s Mohamed Elsayed faced teammate Ahmad Elsokkary in the final match, winning with a 13-9 score. In the semifinal round, Elsokkary won against South Africa’s Harry Saner, 15-12, while Elsayed defeated Côte d'Ivoire's Bedi Paul Alex Beugre, 15-10. In individual women’s foil, Egypt’s Nora Mohamed faced Morocco’s Youssra Zakarani in the final match, winning with a 15-9 score. In the semifinal round, Zakarani won against Egypt’s Yara Elsharkawy, 15-9, while Mohamed defeated teammate Noha Hany, 15-9. Individual Men’s Epee (31 fencers) 1. Mohamed Elsayed (EGY, gold) 2. Ahmad Elsokkary (EGY, silver) 3. Bedi Paul Alex Beugre (CIV, bronze) 3. Harry Saner (RSA, bronze) 5. Mohamed Yasseen (EGY) 6. Pavel Tychler (RSA) 7. Sergey Losevskiy (RSA) 8. Raphael Jacques Hoareau-Berkani (ALG)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="69-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg69Anim = new TimelineMax();
        pg69Anim
          .fromTo(idOf("69-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg69Anim.stop();
        resetNumbers("69-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "In individual women’s epee, Egypt’s Nardin Ehab faced her teammate, Shirwit Gaber, in the final match, winning with a 15-11 score. In the semifinal round, Gaber won against her teammate, Aya Hussain, 15-10, while Ehab defeated Senegal’s Ndeye Binta Diongue, 15-6.  FIE & NATIONAL FEDERATION NEWS 3 OF 6  Individual Women’s Foil (15 fencers) 1. Nora Mohamed (EGY, gold) 2. Youssra Zakarini (MAR, silver) 3. Yara Elsharkawy (EGY, bronze) 3. Noha Hany (EGY, bronze) 5. Meriem Mebarki (ALG) 6. Chaima Nihal Guemmar (ALG) 7. Nourane B’Chir (TUN) 8. Mariam Elzoheiry (EGY)  Day 2 In individual men’s sabre, Tunisia’s Fares Ferjani faced Egypt’s Medhat Moataz in the final match, winning with a 15-14 score. In the semifinal round, Moataz won against his teammate, Mohamed Amer, 15-14, while Ferjani defeated his teammate, Ahmed Ferjani, 15-14.  Individual Men’s Sabre (30 fencers) 1. Fares Ferjani (TUN, gold) 2. Medhat Moataz (EGY, silver) 3. Mohamed Amer (EGY, bronze) 3. Ahmed Ferjani (TUN, bronze) 5. Adham Moataz (EGY) 6. Ziad Elsissy (EGY) 7. Amenallah Hmissi (TUN) 8. Evann Jean Abba Girault (NIG) Individual Women’s Epee (24 fencers) 1. Nardin Ehab (EGY, gold) 2. Shirwit Gaber (EGY, silver) 3. Ndeye Binta Diongue (SEN, bronze) 3. Aya Hussein (EGY, bronze) 5. Camilia El Kord (MAR) 6. Chloe Bousfiha (MAR) 6. Aphiwe Tuku (RSA) 8. Aminata Sabaly (SEN)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="70-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg70Anim = new TimelineMax();
        pg70Anim
          .fromTo(idOf("70-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg70Anim.stop();
        resetNumbers("70-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "In individual women’s sabre, Algeria’s Zohra Nora Kehli faced Egypt’s Nada Hafez in the final match, winning with a 15-10 score. In the semifinal round, Hafez won against Algeria’s Saoussen Boudiaf, 15-14, while Kehli defeated Egypt’s Mariam Deghiedy, 15-8.  FIE & NATIONAL FEDERATION NEWS 4 OF 6  Individual Men’s Foil (23 fencers) 1. Alaaeldin Abouelkassem (EGY, gold) 2. Mohamed Hamza (EGY, silver) 3. Mohamed Hassan (EGY, bronze) 3. Youcef Madi (ALG, bronze) 5. Jeremy Fafa Keryhuel (CIV) 6. Mohamed Aziz Metoui (TUN) 7. Mohamed Essam (EGY) 8. Victor Alvares De Oliveira (CPV)  Day 3 In individual men’s foil, Egypt’s Alaaeldin Abouelkassem faced teammate Mohamed Hamza in the final match, winning with a 1514 score. In the semifinal round, Hamza won against Algeria’s Youcef Madi, 15-7, while Abouelkassem defeated teammate Mohamed Hassan, 15-11.  Individual Women’s Sabre (20 fencers) 1. Zohra Nora Kehli (ALG, gold) 2. Nada Hafez (EGY, silver) 3. Mariam Deghiedy (EGY, bronze) 3. Saoussen Boudiaf (ALG, bronze) 5. Yasmine Daghfous (TUN) 6. Abik Boungab (ALG) 7. Manal Saraa (MAR) 8. Rania Ferjani (TUN)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="71-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg71Anim = new TimelineMax();
        pg71Anim
          .fromTo(idOf("71-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg71Anim.stop();
        resetNumbers("71-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 5 OF 6  Day 4 In men’s team foil, Egypt faced Algeria, winning with a 45-20 score in the final match. In the semifinal round, Algeria won against Tunisia, 45-32, while Egypt defeated Cote D’Ivoire, 45-11. The bronze medal went to Tunisia over Cote D’Ivoire, 45-42. In women’s team sabre, Algeria faced Tunisia, winning with a 45-27 score in the final match. In the semifinal round, Tunisia won against Morocco, 45-24, while Algeria defeated Egypt, 45-41. The bronze medal went to Egypt over Morocco, 45-24.  5. Ghana 6. Morocco  In women’s team epee, Egypt faced Morocco, winning with a 45-30 score in the final match. In the semifinal round, Morocco won against Senegal, 45-41, while Egypt defeated Algeria, 45-35. The bronze medal went to Algeria over Senegal, 45-43.  Women’s Team Sabre (6 countries) 1. Algeria (gold) 2. Tunisia (silver) 3. Egypt (bronze) 4. Morocco 5. Cote D’Ivoire 5. Senegal  Men’s Team Foil (6 countries) 1. Egypt (gold) 2. Algeria (silver) 3. Tunisia (bronze) 4. Cote D’Ivoire  Women’s Team Epee (4 countries) 1. Egypt (gold) 2. Morocco (silver) 3. Algeria (bronze) 4. Senegal"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="72-next" class="halfScale pointer" style="top:658px;right:-81px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg72Anim = new TimelineMax();
        pg72Anim
          .fromTo(idOf("72-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg72Anim.stop();
        resetNumbers("72-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 6 OF 6  Day 5 In men’s team epee, Egypt faced Morocco, winning with a 45-34 score in the final match. In the semifinal round, Morocco won against Senegal, 45-34, while Egypt defeated South Africa, 45-33. The bronze medal went to South Africa over Senegal, 45-33. In men’s team sabre, Tunisia faced Egypt, winning with a 45-42 score in the final match. In the semifinal round, Egypt won against Mali, 45-18, while Tunisia defeated Algeria, 45-25. The bronze medal went to Algeria over Mali, 45-39.  5. Algeria 6. Tunisia 7. Libya 8. Cote D’Ivoire  In women’s team foil, Egypt faced Algeria, winning with a 45-23 score in the final match. In the semifinal round, Algeria won against Morocco, 45-23, while Egypt defeated Cote D’Ivoire, 45-6. The bronze medal went to Morocco over Cote D’Ivoire, 45-22.  Men’s Team Sabre (6 countries) 1. Tunisia (gold) 2. Egypt (silver) 3. Algeria (bronze) 4. Mali 5. Senegal 6. Cote D’Ivoire 6. Morocco  Men’s Team Epee (9 countries) 1. Egypt (gold) 2. Morocco (silver) 3. South Africa (bronze) 4. Senegal  Women’s Team Foil (4 countries) 1. Egypt (gold) 2. Algeria (silver) 3. Morocco (bronze) 4. Cote D’Ivoire ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": `

    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
        <img src="/121/en/static/_mobile/73-mobile-1.jpg">
    `,      
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": `
    <img class="abs halfScale197 74-title" style="top:341px;left:678px;" src="/121/en/static/_content/74-title-1.png">
    <img class="abs halfScale197 74-sub" style="top:534px;left:710px;" src="/121/en/static/_content/74-sub-1.png">
    <img class="abs halfScale197 74-line" style="top:537px;left:677px;" src="/121/en/static/_content/74-line-1.png">
    <img id="74-next" class="halfScale pointer" style="top:659px;right:-97px" onclick="Publish.goToNextPage()"
      src="/121/en/static/_content/arrow-edge-green.png">
  `,
  "script": `
    function onPageEnter() {
      pg74Anim = new TimelineMax();
      pg74Anim
        .fromTo(cOf("74-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        .fromTo(cOf("74-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
        .fromTo(cOf("74-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
        .fromTo(idOf("74-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
    }
  
    function onPageLeave() {
      pg74Anim.stop();
      resetNumbers("74-no");
      removeContentLinks();
      removeContentLinksThree();
    }
  `,
    "searchText": "SP ORT  EUROPEAN SENIOR FENCING CHAMPIONSHIPS FINISH IN ANTALYA ANTALYA, TÜRKIYE 17–22 JUNE 2022",
    "mobileHtml":`
    <h2>European Senior Fencing Championships Finish in Antalya</h2>
      <img src="/121/en/static/_mobile/74-mobile-1.png">
      <p><strong>Antalya, Türkiye</strong><br>
    17–22 June 2022</p>
    <p>The 2022 European Senior Fencing Championships have finished, including 12 men’s and women’s individual and team events in epee, foil and sabre.</p>
    <p>The event took place at the Antalya Spor Solonu, with 433 individual fencers and 35 countries participating. Italy won the medal count, including 14 overall (4 gold, 7 silver and 3 bronze), followed by France with 11 (3 gold, 2 silver, 6 bronze) and Ukraine with 4 (1 gold, 1 silver, 2 bronze).</p>

    <p><strong>Day 1</strong></p>
    <p>In individual men’s sabre, Georgia’s Sandro Bazadze faced Italy’s Luca Curatoli in the final match, winning with a 15-11 score. In the semifinal round, Curatoli won against France’s Bolade Apithy, 15-11, while Bazadze defeated France’s Eliott Bibi, 15-4. Of note, Romania’s Iulian Teodosiu beat Hungarian world champion Andras Szatmari in the round of 16, 15-13, before losing to Apithy in the quarterfinals, 15-10.</p>
    <p>In individual women’s foil, Germany’s Leonie Ebert faced Italian two-time world champion Arianna Errigo in the final match, winning with a 15-11 score. In the semifinal round, Errigo won against France’s Ysaora Thibus, 15-11, while Ebert defeated Italian world champion Alice Volpi, 15-9.</p>

    <p><strong>Individual Men’s Sabre (55 fencers)</strong><br>
    1. Sandro Bazadze (GEO, gold)<br>
2. Luca Curatoli (ITA, silver)<br>
3. Bolade Apithy (FRA, bronze)<br>
3. Eliott Bibi (FRA, bronze)<br>
5. Razvan Ursachi (ROU)<br>
6. Iulian Teodosiu (ROU)<br>
7. Beka Bazadze (GEO)<br>
8. Csanad Gemesi (HUN)
    </p>

    <p><strong>Individual Women’s Foil (59 fencers)</strong><br>
    1. Leonie Ebert (GER, gold)<br>
2. Arianna Errigo (ITA, silver)<br>
3. Ysaora Thibus (FRA, bronze)<br>
3. Alice Volpi (ITA, bronze)<br>
5. Anne Sauer (GER)<br>
6. Carolina Stutchbury (GBR)<br>
7. Francesca Palumbo (ITA)<br>
8. Kata Kondricz (HUN)
    </p>

    <p><strong>Day 2</strong></p>
    <p>In individual men’s foil, Italy’s Daniele Garozzo faced teammate Tommaso Marini in the final match, winning with a 15-9 score. In the semifinal round, Marini won against France’s Maximilien Chastanet, 15-6, while Garozzo defeated teammate Giorgio Avola, 15-10. Of note, Chastanet beat Italian world champion Alessio Foconi in the quarterfinals, 15-13.</p>
    <p>In individual women’s epee, Ukraine’s Vlada Kharkova faced Italian two-time world champion Rossella Fiamingo in the final match, winning with a 15-10 score. In the semifinal round, Fiamingo won against teammate and world champion Mara Navarria, 7-6, while Kharkova defeated Poland’s Martyna Swatowska-Wenglarczyk, 15-10.</p>

    <p><strong>Individual Men’s Foil (70 fencers)</strong><br>
    1. Daniele Garozzo (ITA, gold)<br>
2. Tommaso Marini (ITA, silver)<br>
3. Maximilien Chastanet (FRA, bronze)<br>
3. Giorgio Avola (ITA, bronze)<br>
5. Alexander Choupenitch (CZE)<br>
6. Alexandre Sido (FRA)<br>
7. Carlos Llavador (ESP)<br>
8. Alessio Foconi (ITA)
    </p>

    <p><strong>Individual Women’s Epee (86 fencers)</strong><br>
    1. Vlada Kharkova (UKR, gold)<br>
2. Rossella Fiamingo (ITA, silver)<br>
3. Martyna Swatowska-Wenglarczyk (POL, bronze)<br>
3. Mara Navarria (ITA, bronze)<br>
5. Eszter Muhari (HUN)<br>
6. Alexandra Ndolo (GER)<br>
7. Erika Kirpu (EST)<br>
8. Pauline Brunner (SUI)
    </p>

    <p><strong>Day 3</strong></p>
    <p>In individual men’s epee, France’s world champion Yannick Borel faced the Netherlands’ Tristan Tulen, winning with a 15-1 score in the final match. In the semifinal round, Tulen won against Switzerland’s Alexis Bayard, 15-14, while Borel defeated Switzerland’s Max Heinzer, 15-11.</p>
    <p>In individual women’s sabre, Azerbaijan’s Anna Bashta faced Italy’s Rossella Gregorio, winning with a 15-9 score in the final match. In the semifinal round, Gregorio won against France’s Sara Balzer, 15-11, while Bashta defeated Poland’s Zuzanna Cieslar, 15-6. Of note, Bashta beat Ukraine’s four-time world champion Olga Kharlan in the quarterfinals, 15-14.</p>

    <p><strong>Individual Men’s Epee (102 fencers)</strong><br>
    1. Yannick Borel (FRA, gold)<br>
2. Tristan Tulen (NED, silver)<br>
3. Alexis Bayard (SUI, bronze)<br>
3. Max Heinzer (SUI, bronze)<br>
5. Jakub Jurka (CZE)<br>
6. Neisser Loyola (BEL)<br>
7. Richard Schmidt (GER)<br>
8. Marco Brinkmann (GER)
    </p>

    <p><strong>Individual Women’s Sabre (61 fencers)</strong><br>
    1. Anna Bashta (AZE, gold)<br>
2. Rossella Gregorio (ITA, silver)<br>
3. Sara Balzer (FRA, bronze)<br>
3. Zuzanna Cieslar (POL, bronze)<br>
5. Olga Kharlan (UKR)<br>
6. Caroline Queroli (FRA)<br>
7. Larissa Eifler (GER)<br>
8. Araceli Navarro (ESP)
    </p>

    <p><strong>Day 4</strong></p>
    <p>In men’s team sabre, Hungary faced Ukraine in the final match, winning with a 40-39 score. In the semifinal round, Ukraine won against Türkiye, 45-43, while Hungary defeated France, 45-35. The bronze medal went to Türkiye over France, 45-39.</p>
    <p>In women’s team foil, Italy faced France in the final match, winning with a 45-25 score. In the semifinal round, France won against Poland, 45-28, while Italy defeated Germany, 45-23. The bronze medal went to Germany over Poland, 45-31.</p>

    <p><strong>Men’s Team Sabre (12 countries)</strong><br>
    1. Hungary (gold)<br>
2. Ukraine (silver)<br>
3. Türkiye (bronze)<br>
4. France<br>
5. Romania<br>
6. Germany<br>
7. Italy<br>
8. Poland
    </p>

    <p><strong>Women’s Team Foil (11 countries)</strong><br>
    1. Italy (gold)<br>
2. France (silver)<br>
3. Germany (bronze)<br>
4. Poland<br>
5. Spain<br>
6. Ukraine<br>
7. Hungary<br>
8. Romania
    </p>

    <p><strong>Day 5</strong></p>
    <p>In men’s team foil, Italy faced France in the final match, winning with a 45-38 score. In the semifinal round, France won against Poland, 42-36, while Italy defeated Spain, 45-19. The bronze medal wen to Poland over Spain, 45-29. In women’s team epee, France faced Italy in 
    the final, winning with a 43-30 score. In the semifinal round, Italy won against Switzerland, 45-32, while France defeated Ukraine, 45-36. The bronze medal went to Ukraine over Switzerland, 45-42.</p>

    <p><strong>Men’s Team Epee (9 countries)</strong><br>
    1. Egypt (gold)<br>
2. Morocco (silver)<br>
3. South Africa (bronze)<br>
4. Senegal<br>
5. Algeria<br>
6. Tunisia<br>
7. Libya<br>
8. Cote D’Ivoire
    </p>

    <p><strong>Men’s Team Foil (15 countries)</strong><br>
    1. Italy (gold)<br>
2. France (silver)<br>
3. Poland (bronze)<br>
4. Spain<br>
5. Ukraine<br>
6. Germany<br>
7. Great Britain<br>
8. Belgium
    </p>

    <p><strong>Women’s Team Epee (19 countries)</strong><br>
    1. France (gold)<br>
2. Italy (silver)<br>
3. Ukraine (bronze)<br>
4. Switzerland<br>
5. Hungary<br>
6. Sweden<br>
7. Poland<br>
8. Germany
    </p>
    `
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="75-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg75Anim = new TimelineMax();
        pg75Anim
          .fromTo(idOf("75-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg75Anim.stop();
        resetNumbers("75-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 7  The 2022 European Senior Fencing Championships have finished, including 12 men’s and women’s individual and team events in epee, foil and sabre. The event took place at the Antalya Spor Solonu, with 433 individual fencers and 35 countries participating. Italy won the medal count, including 14 overall (4 gold, 7 silver and 3 bronze), followed by France with 11 (3 gold, 2 silver, 6 bronze) and Ukraine with 4 (1 gold, 1 silver, 2 bronze).  In individual women’s foil, Germany’s Leonie Ebert faced Italian two-time world champion Arianna Errigo in the final match, winning with a 15-11 score. In the semifinal round, Errigo won against France’s Ysaora Thibus, 15-11, while Ebert defeated Italian world champion Alice Volpi, 15-9.  Day 1  Individual Men’s Sabre (55 fencers) 1. Sandro Bazadze (GEO, gold) 2. Luca Curatoli (ITA, silver) 3. Bolade Apithy (FRA, bronze) 3. Eliott Bibi (FRA, bronze) 5. Razvan Ursachi (ROU) 6. Iulian Teodosiu (ROU) 7. Beka Bazadze (GEO) 8. Csanad Gemesi (HUN)  In individual men’s sabre, Georgia’s Sandro Bazadze faced Italy’s Luca Curatoli in the final match, winning with a 15-11 score. In the semifinal round, Curatoli won against France’s Bolade Apithy, 15-11, while Bazadze defeated France’s Eliott Bibi, 15-4. Of note, Romania’s Iulian Teodosiu beat Hungarian world champion Andras Szatmari in the round of 16, 15-13, before losing to Apithy in the quarterfinals, 15-10.  Individual Women’s Foil (59 fencers) 1. Leonie Ebert (GER, gold) 2. Arianna Errigo (ITA, silver)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="76-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg76Anim = new TimelineMax();
        pg76Anim
          .fromTo(idOf("76-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg76Anim.stop();
        resetNumbers("76-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "Rossella Fiamingo in the final match, winning with a 15-10 score. In the semifinal round, Fiamingo won against teammate and world champion Mara Navarria, 7-6, while Kharkova defeated Poland’s Martyna SwatowskaWenglarczyk, 15-10.  FIE & NATIONAL FEDERATION NEWS 3 OF 7  3. Ysaora Thibus (FRA, bronze) 3. Alice Volpi (ITA, bronze) 5. Anne Sauer (GER) 6. Carolina Stutchbury (GBR) 7. Francesca Palumbo (ITA) 8. Kata Kondricz (HUN)  Day 2 In individual men’s foil, Italy’s Daniele Garozzo faced teammate Tommaso Marini in the final match, winning with a 15-9 score. In the semifinal round, Marini won against France’s Maximilien Chastanet, 15-6, while Garozzo defeated teammate Giorgio Avola, 15-10. Of note, Chastanet beat Italian world champion Alessio Foconi in the quarterfinals, 15-13. In individual women’s epee, Ukraine’s Vlada Kharkova faced Italian two-time world champion  Individual Men’s Foil (70 fencers) 1. Daniele Garozzo (ITA, gold) 2. Tommaso Marini (ITA, silver) 3. Maximilien Chastanet (FRA, bronze) 3. Giorgio Avola (ITA, bronze) 5. Alexander Choupenitch (CZE) 6. Alexandre Sido (FRA) 7. Carlos Llavador (ESP) 8. Alessio Foconi (ITA) Individual Women’s Epee (86 fencers) 1. Vlada Kharkova (UKR, gold) 2. Rossella Fiamingo (ITA, silver) 3. Martyna SwatowskaWenglarczyk (POL, bronze) 3. Mara Navarria (ITA, bronze) 5. Eszter Muhari (HUN) 6. Alexandra Ndolo (GER) 7. Erika Kirpu (EST) 8. Pauline Brunner (SUI)"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="77-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg77Anim = new TimelineMax();
        pg77Anim
          .fromTo(idOf("77-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg77Anim.stop();
        resetNumbers("77-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "Individual Men’s Epee (102 fencers) 1. Yannick Borel (FRA, gold) 2. Tristan Tulen (NED, silver) 3. Alexis Bayard (SUI, bronze) 3. Max Heinzer (SUI, bronze) 5. Jakub Jurka (CZE) 6. Neisser Loyola (BEL) 7. Richard Schmidt (GER) 8. Marco Brinkmann (GER)  FIE & NATIONAL FEDERATION NEWS 4 OF 7  Day 3 In individual men’s epee, France’s world champion Yannick Borel faced the Netherlands’ Tristan Tulen, winning with a 15-1 score in the final match. In the semifinal round, Tulen won against Switzerland’s Alexis Bayard, 15-14, while Borel defeated Switzerland’s Max Heinzer, 15-11. In individual women’s sabre, Azerbaijan’s Anna Bashta faced Italy’s Rossella Gregorio, winning with a 15-9 score in the final match. In the semifinal round, Gregorio won against France’s Sara Balzer, 15-11, while Bashta defeated Poland’s Zuzanna Cieslar, 15-6. Of note, Bashta beat Ukraine’s four-time world champion Olga Kharlan in the quarterfinals, 15-14.  Individual Women’s Sabre (61 fencers) 1. Anna Bashta (AZE, gold) 2. Rossella Gregorio (ITA, silver) 3. Sara Balzer (FRA, bronze) 3. Zuzanna Cieslar (POL, bronze) 5. Olga Kharlan (UKR) 6. Caroline Queroli (FRA) 7. Larissa Eifler (GER) 8. Araceli Navarro (ESP)  Day 4 In men’s team sabre, Hungary faced Ukraine in the final match, winning with a 40-39 score. In the semifinal round, Ukraine won against Türkiye, 45-43, while Hungary defeated France, 45-35. The bronze medal went to Türkiye over France, 45-39."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": `
    <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
        src="/121/en/static/_content/tw-green.png">
    </a>
  
    <a href="https://www.facebook.com/fie.org" target="_blank">
      <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
        src="/121/en/static/_content/fb-green.png">
    </a>
  
    <img id="78-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
      src="/121/en/static/_content/arrow-edge-green.png">
  
    <a href="http://www.fie.org" target="_blank">
      <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
    </a>
  `,
  "script": `
    function onPageEnter() {
      pg78Anim = new TimelineMax();
      pg78Anim
        .fromTo(idOf("78-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
    }
  
    function onPageLeave() {
      pg78Anim.stop();
      resetNumbers("78-no");
      removeContentLinks();
      removeContentLinksThree();
    }
  `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 5 OF 7  In women’s team foil, Italy faced France in the final match, winning with a 45-25 score. In the semifinal round, France won against Poland, 45-28, while Italy defeated Germany, 45-23. The bronze medal went to Germany over Poland, 45-31. Men’s Team Sabre (12 countries) 1. Hungary (gold) 2. Ukraine (silver) 3. Türkiye (bronze) 4. France  5. Romania 6. Germany 7. Italy 8. Poland Women’s Team Foil (11 countries) 1. Italy (gold) 2. France (silver) 3. Germany (bronze) 4. Poland 5. Spain 6. Ukraine 7. Hungary 8. Romania  Day 5 In men’s team foil, Italy faced France in the final match, winning with a 45-38 score. In the semifinal round, France won against Poland, 42-36, while Italy defeated Spain, 45-19. The bronze medal wen to Poland over Spain, 45-29. In women’s team epee, France faced Italy in the final, winning with a 43-30 score. In the semifinal round, Italy won against Switzerland, 45-32, while France defeated Ukraine, 4536. The bronze medal went to Ukraine over Switzerland, 45-42."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="79-next" class="halfScale pointer" style="top:658px;right:-97px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg79Anim = new TimelineMax();
        pg79Anim
        .fromTo(idOf("79-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg79Anim.stop();
        resetNumbers("79-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 6 OF 7  Men’s Team Foil (15 countries) 1. Italy (gold) 2. France (silver) 3. Poland (bronze) 4. Spain 5. Ukraine 6. Germany 7. Great Britain 8. Belgium Women’s Team Epee (19 countries) 1. France (gold) 2. Italy (silver) 3. Ukraine (bronze) 4. Switzerland 5. Hungary 6. Sweden 7. Poland 8. Germany  Day 6 In men’s team epee, Italy faced Israel in the final match, winning with a 45-32 score. In the semifinal round, Israel won against Denmark, 45-44, while Italy defeated France, 45-44. The bronze medal went to France over Denmark, 45-41. In women’s team sabre, France faced Italy in the final match, winning with a 45-23 score. In the semifinal round, Italy won against Hungary, 45-38, while France defeated Ukraine, 4543. The bronze medal went to Ukraine over Hungary, 45-41."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:42px"
          src="/121/en/static/_content/tw-green.png">
      </a>
    
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:329px;left:95px"
          src="/121/en/static/_content/fb-green.png">
      </a>
    
      <img id="80-next" class="halfScale pointer" style="top:658px;right:-81px" onclick="Publish.goToNextPage()"
        src="/121/en/static/_content/arrow-edge-green.png">
    
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
        pg80Anim = new TimelineMax();
        pg80Anim
          .fromTo(idOf("80-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }
    
      function onPageLeave() {
        pg80Anim.stop();
        resetNumbers("80-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "FIE & NATIONAL FEDERATION NEWS 7 OF 7  Men’s Team Epee (21 countries) 1. Italy (gold) 2. Israel (silver) 3. France (bronze) 4. Denmark 5. Switzerland 6. Ukraine 7. Hungary 8. Poland  Women’s Team Sabre (13 countries) 1. France (gold) 2. Italy (silver) 3. Ukraine (bronze) 4. Hungary 5. Spain 6. Greece 7. Germany 8. Türkiye ■  W W W.FIE .ORG"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": `
      <a href="mailto:jason@jiangfencing.com" target="_blank">
        <div class="contentLinkNone" style="bottom: 76px; right: 362px; width: 235px; height: 19px;"></div>
      </a>
      <a href="http://www.jiangfencing.com" target="_blank">
        <div class="contentLinkNone" style="bottom: 97px; right: 387px; width: 211px; height: 17px;"></div>
      </a>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "mobileHtml": `
      <a href="http://www.jiangfencing.com" target="_blank">
        <img src="/121/en/static/_mobile/81-mobile-1.jpg">
      </a>
    `,      
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": `
        <img class="abs halfScale 82-title" style="top:67px;left:58px;" src="/121/en/static/_content/82-title-1.png">

        <img id="82-next" class="halfScale pointer" style="top:719px;right:-186px" onclick="Publish.goToNextPage()"
          src="/121/en/static/_content/arrow-long-navy.png">
        
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div id="82-1" class="abs noOverflow 82-div" style="top:265px; left: 65px; height: 560px; width: 810px; display: block;">
          <img id="82-text-1a" class="halfScale 82-text-1" style="top:0px;left:0px;"
            src="/121/en/static/_content/82-text-1-1.png">
          <img id="82-text-1b" class="halfScale 82-text-1" style="top:0px;left:0px; opacity:0;"
            src="/121/en/static/_content/82-text-1-2.png">
          <img id="82-text-1c" class="halfScale 82-text-1" style="top:0px;left:0px; opacity:0;"
            src="/121/en/static/_content/82-text-1-3.png">
          <div id="82-btn-1a" class="abs halfScale pointer 82-btn-1"
            style="top: 479px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('82-btn-1a', '82-btn-1', '82-text-1a', '82-text-1')"></div>
          <div id="82-btn-1b" class="abs halfScale pointer 82-btn-1"
            style="top: 479px; left: 534px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('82-btn-1b', '82-btn-1', '82-text-1b', '82-text-1')"></div>
          <div id="82-btn-1c" class="abs halfScale pointer 82-btn-1"
            style="top: 479px; left: 668px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('82-btn-1c', '82-btn-1', '82-text-1c', '82-text-1')"></div>
        </div>
        
        <div id="82-2" class="abs noOverflow 82-div" style="top:265px;left:65px;height:560px;width:880px;display:none">
          <img id="82-text-2a" class="halfScale 82-text-2" style="top:0px;left:0px;"
            src="/121/en/static/_content/82-text-2-1.png">
          <img id="82-text-2b" class="halfScale 82-text-2" style="top:0px;left:0px; opacity:0;"
            src="/121/en/static/_content/82-text-2-2.png">
          <img id="82-text-2c" class="halfScale 82-text-2" style="top:0px;left:0px; opacity:0;"
            src="/121/en/static/_content/82-text-2-3.png">
          <div id="82-btn-2a" class="abs halfScale pointer 82-btn-2"
            style="top: 479px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('82-btn-2a', '82-btn-2', '82-text-2a', '82-text-2')"></div>
          <div id="82-btn-2b" class="abs halfScale pointer 82-btn-2"
            style="top: 479px; left: 534px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('82-btn-2b', '82-btn-2', '82-text-2b', '82-text-2')"></div>
          <div id="82-btn-2c" class="abs halfScale pointer 82-btn-2"
            style="top: 479px; left: 668px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('82-btn-2c', '82-btn-2', '82-text-2c', '82-text-2')"></div>
        </div>
      
        
        <img id="82-cta-1" class="halfScale pointer 82-btn" style="top:265px;left:883px;transform:scale(0.506,0.52);"
          onclick="pg82Toggle('82-1', '82-cta-1');" src="/121/en/static/_content/82-name-1.png">
        <img id="82-cta-2" class="halfScale pointer 82-btn" style="top:334px;left:886px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg82Toggle('82-2', '82-cta-2');" src="/121/en/static/_content/82-name-2.png">
      `,
      "script": `
      function onPageEnter() {
        pg82Anim = new TimelineMax();
        pg82Anim
          .to(idOf("82-1"), 0.3,{display: 'block'}, 0)
          .fromTo(cOf("82-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(idOf("82-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
      }

      function pg82Toggle(id, btn) {
        var ele = idOf(id)
        var but = idOf(btn)
        TweenMax.to(cOf("82-div"), 0.01, {display: 'none'});
        TweenMax.to(cOf("82-btn"), 0.01, {opacity: 0});
        TweenMax.to(ele, 0.1, {display: 'block'});
        TweenMax.to(but, 0.1, {opacity: 1});
        console.log(id)
        console.log(btn)
      }
      
      function togglePage(id, klass, text, texttwo) {
        var ele = idOf(id)
        var but = cOf(klass)
        var txt = idOf(text)
        var txt2 = cOf(texttwo)
        TweenMax.to(but, 0.01, {opacity: 0});
        TweenMax.to(txt2, 0.01, {opacity: 0});
        TweenMax.to(ele, 0.01, {opacity:1});
        TweenMax.to(txt, 0.01, {opacity:1});
      }
      
      function onPageLeave(){
        pg82Toggle('82-text-1', '82-cta-1');
        togglePage('82-btn-1', '82-btn-2', '82-text-1', '82-text-1');
        pg82Anim.stop();
        resetNumbers("53-no");
        removeContentLinks();
        removeContentLinksThree();
      }
    `,
    "searchText": "REMEMBR AN CE  OBITUARIES MARK RANCE  MARK RANCE (NZL)  DANIEL R. DECHAINE JR.  The FIE is saddened to learn of the passing of Mark Rance (NZL), on May 3, 2022 in Christchurch, New Zealand. He was the current president of the FIE Veterans Council until his passing and had been a member since 2016. Mr. Rance was elected to the Oceania Fencing Confederation board in 2020 and then elected vice president by the board, serving from 2020 until now. He was president of Fencing New Zealand from 2017 until October, 2021. In 2016, Mr. Rance was the chair of the organising committee for the Christchurch Commonwealth Veterans Fencing Championships, named as a  s Click Above to View finalist in the Canterbury Sports Awards. He also took a silver medal as part of the men’s epee team at the same event. “Mark combined his love of fencing and sound business skills when working with the Veterans Council to get the best outcomes for veteran fencing worldwide”, said Rita Comes (USA), on behalf of the FIE Veterans Council. “His presence will be missed.”  1  2  3  W W W.FIE .ORG",
    "mobileHtml":`
    <h2>Mark Rance (NZL)</h2>
      <img src="/121/en/static/_mobile/82-mobile-1.png">
    <p><strong>The FIE is saddened to learn of the passing of Mark Rance (NZL), on May 3, 2022 in Christchurch, New Zealand.</strong></p>
    <p>He was the current president of the FIE Veterans Council until his passing and had been a member since 2016. Mr. Rance was elected to the Oceania Fencing Confederation board in 2020 and then elected vice president by the board, serving from 2020 until now. He was president of Fencing New Zealand from 2017 until October, 2021.</p>
    <p>In 2016, Mr. Rance was the chair of the organising committee for the Christchurch Commonwealth Veterans Fencing Championships, named as a finalist in the Canterbury Sports Awards. He also took a silver medal as part of the men’s epee team at the same event.</p>
    <p>“Mark combined his love of fencing and sound business skills when working with the Veterans Council to get the best outcomes for veteran fencing worldwide”, said Rita Comes (USA), on behalf of the FIE Veterans Council. “His presence will be missed.” Originally from England, and born on February 7, 1963, Mr. Rance was a competitive swimmer before discovering fencing at the age of 10. He fenced at the Reading Club and then at the London Thames Fencing Club for several years, achieving strong results in both regional and national events, and later participated in European tournaments and finished in the top 12 epeeists in the 1983 Junior World Championship. In the 1980s, he was considered for being a member of the British Olympic team, although several issues and an injury prevented him from attaining that goal.</p>
    <p>Mr. Rance moved to New Zealand in the 1990s, where he lived in the South Island town of Ashburton. After a hiatus from fencing, in 2008 his passion for the sport reignited after attending an epee tournament in Christchurch; he shortly thereafter made the podium at the New Zealand Men’s National Championships. From there, he went on to represent New Zealand in both senior and veteran events globally, and in 2010 won a bronze medal in veteran individual men’s epee and silver in veteran men’s team epee at the Commonwealth Fencing Championships in Melbourne, Australia.</p>
    <p>“Mark was always a man who was willing to help, particularly with the young people of our sport who he coached and mentored for several years”, stated David Elder, Fencing New Zealand president. “Many young fencers will sorely miss his advice and expertise.”</p>
    <p>According to Mr. Elder, for a significant period Mr. Rance was the highest-ranked men’s veteran epeeist in Australasia (Australia and New Zealand).</p>
    <p>The FIE extends its sincere condolences to Mark Rance’s family and friends, Fencing New Zealand and the Oceania Fencing Confederation. We express our deepest sympathy 
    to them during this difficult time.</p>

    <h2>Daniel R. DeChaine Jr. (USA) </h2>
      <img src="/121/en/static/_mobile/82-mobile-2.png">
    <p><strong>The FIE is saddened to learn of the passing on May 20, 2022 of Daniel R. DeChaine, Jr. (USA), a member of the FIE SEMI Commission for more than 30 years.
    </strong></p>
    <p>Born on October 29, 1934 in California, USA, he was best-known for his extensive work as a fencing armorer. He was elected to the SEMI Commission in 1985, serving until 2016. In that role, he was the chief armorer/technician and SEMI Commission representative at numerous world fencing events, including the Pan American Games; Junior, Cadet and Senior Fencing World Championships; and numerous other events. At the 1984 Los Angeles Olympic Games, he was the technical manager of fencing and the manager of armorers.</p>
    <p>In addition to armory, Mr. DeChaine invented, designed and constructed test devices for fencing, including ones used at the 1976 and 1984 Olympic Games.</p>
    <p>“For decades, Team USA athletes put their trust in Dan DeChaine”, said David Arias, chair of the USA Fencing Board of Directors. “With Dan in their corner, our athletes knew they were in good hands. Through his work with the SEMI Commission of the FIE, Dan helped design rules for fencing equipment and invent the test devices that ensured all fencers had an even playing field. With the passing of Dan DeChaine, the international fencing community has lost a legend of the sport. His legacy will be felt at local, regional, national and international fencing tournaments for generations.”</p>
    <p>In 2007, Mr. DeChaine was inducted into the USA Fencing Hall of Fame, in part for his extensive contributions as the national team armorer at the Olympic Games, World Championships, World University Games and Pan American Games dating back to 1967. He was also the official fencing armorer for the Modern Pentathlon World Championships as well as a consultant to many national fencing federations on armory, equipment and equipment selection. He served terms as the chairman and co-chairman of the National Technical Commission of the United States Fencing Association and authored numerous articles on equipment repair, maintenance and troubleshooting. Mr. DeChaine earned a Bachelor of Arts degree in Zoology from Pomona College in 1956.</p>
    <p>The FIE extends its sincere condolences to Dan DeChaine’s family and friends, USA Fencing and the Pan American Fencing Confederation. We express our deepest sympathy to them during this difficult time.</p>
    `
  }]],
  "script": `
    function idOf(id) {
      return document.getElementById(id)
    }

    function cOf(klass) {
      return document.getElementsByClassName(klass)
    }
    
    function removeContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) { 
        return e.className = 'addContentLink'
      })
    }

    function addContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'contentLink addContentLink'
      })
    }

    function showOverlay(idx) {
      idOf(idx).className = 'contentOverlay visible'
    }

    function hideOverlay(idx) {
      idOf(idx).className = 'contentOverlay hidden noclick'
    }

    function animateNumber(element){
      if(element.getAttribute("data-number")){
        var args = JSON.parse(element.getAttribute("data-number"));
        var from = 0;
        var to = 100;
        var append = "";
        var preppend = "";
        var decimals = 0;
        var duration = 1;
        var ease = "Linear.easeNone";
        var comma = false;
        var separator = ",";
        var decChar = ".";
        for(obj in args){
          if(obj == "from") from = args[obj];
          if(obj == "to") to = args[obj];
          if(obj == "append") append = args[obj];
          if(obj == "preppend") preppend = args[obj];
          if(obj == "decimals") decimals = args[obj];
          if(obj == "duration") duration = args[obj];
          if(obj == "ease") ease = args[obj];
          if(obj == "comma") comma = args[obj];
          if(obj == "separator") separator = args[obj];
          if(obj == "decChar") decChar = args[obj];
        }
        var obj = {number: from}
        TweenMax.to(obj, duration, {number: to, onUpdate: function(){
          if(comma){
            console.log(obj.number)
            var str = obj.number.toFixed(decimals).toString();
            var predec = str.split(/^d*/)[0];
            console.log("PREDEC", predec, typeof(predec));
            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
            var comp = newstr.replace(/^,/, '')
            console.log("NEWSTR", newstr, typeof(newstr));
            // console.log({newstr})
            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
            // if(dp[0]) dp = dp[0].replace(".", decChar);
            var dp = "";
            element.innerHTML = preppend+comp+dp+append;
          }else{
            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
          }
        }, ease: eval(ease)});
      }else{
        return;
      }
    }

    function resetNumbers(ele){
      var numbers = cOf(ele)
      for(var i=0; i<numbers.length; i++) {
        numbers[i].innerText= ""
      }
    }
  `,
  "mobilePages": [
    {
      title: "Escrime XXI No. 121",
      link: "Escrime XXI No. 121",
      cssClass: "cover mobile-p1",
      hideInMenu: false,
      pageLinks: [
        {
          index: 0,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 2,
          subIndex: 0
        }
      ]
    },
    {
      title: "Comex",
      link: "Comex",
      cssClass: "blue",
      hideInMenu: false,
      pageLinks: [
        {
          index: 4,
          subIndex: 0
        }
      ]
    },
    {
      title: "Editorial",
      link: "Editorial",
      cssClass: "darkblue",
      hideInMenu: false,
      pageLinks: [
        {
          index: 5,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 6,
          subIndex: 0
        }
      ]
    },
    {
      title: "SPORT - Cairo 2022 FWC",
      link: "A Grand Success Cairo 2022 Fencing World Championships Finish ",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 7,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 14,
          subIndex: 0
        }
      ]
    },
    {
      title: "SPORT - Paris",
      link: "France’s Lopez Pourtier, Team Hungary Win Gold at “Challenge Monal” Epee World Cup in Paris",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 15,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "SPORT - Belgrade",
      link: "Italy’s Marini, Germany’s Sauer Win Men’s and Women’s Gold in Belgrade Foil World Cups, Italy and France Win Team Foil",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 17,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "SPORT - Cairo",
      link: "France’s Borel, Korea’s Choi Win Cairo Men’s and Women’s Epee Grand Prix",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 20,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 23,
          subIndex: 0
        }
      ]
    },
    {
      title: "SPORT - Madrid",
      link: "Korea Wins Double Gold at “Villa de Madrid” Men’s Sabre World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 24,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "SPORT - Hammamet",
      link: "Japan’s Emura, Team Korea Win Gold at Women’s Sabre World Cup in Tunisia",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 26,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "SPORT - Heidenheim",
      link: "France’s Cannone, Team Korea Win Heidenheim Men’s Epee World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 28,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "SPORT - Incheon",
      link: "Italy’s Marini, USA’s Kiefer Win Incheon Foil Grand Prix",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 30,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 32,
          subIndex: 0
        }
      ]
    },
    {
      title: "SPORT - Padua",
      link: "Hungary’s Szilagyi, Azerbaijan’s Bashta Win Gold at Padua Sabre Grand Prix",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 33,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "SPORT - Tbilisi",
      link: "Ukraine’s Stankevych, Team Switzerland Win Tbilisi Men’s Epee World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 36,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 39,
          subIndex: 0
        }
      ]
    },
    {
      title: "SPORT - Katowice",
      link: "Korea Takes Double Gold at Katowice Women’s Epee World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 40,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "SPORT - Plovdiv",
      link: "Italy Wins Double Gold in Plovdiv Foil World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 42,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "SPORT - Tauberbischofsheim",
      link: "USA’s Kiefer, Team Italy Win Gold at Tauberbischofsheim Women’s Foil World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 44,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 46,
          subIndex: 0
        }
      ]
    },
    {
      title: "Inside Fencing",
      link: "Inside Fencing",
      cssClass: "pink",
      hideInMenu: false,
      pageLinks: [
        {
          index: 47,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 48,
          subIndex: 0
        }
      ]
    },
    {
      title: "FIE News - USA",
      link: "Fencers Gather for World’s Largest Fencing Tournament of 2022",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 49,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "FIE News - Pan Am",
      link: "Pan American Senior Fencing Championships Finish in Paraguay",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 52,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 58,
          subIndex: 0
        }
      ]
    },
    {
      title: "FIE News - Asia",
      link: "Asian Senior Fencing Championships Finish in Seoul",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 59,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "FIE News - Africa",
      link: "African Senior Fencing Championships Finish in Casablanca",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 66,
          subIndex: 0
        },
        
      ]
    },
    {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 72,
          subIndex: 0
        }
      ]
    },
    {
      title: "FIE News - Europe",
      link: "European Senior Fencing Championships Finish in Antalya",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 73,
          subIndex: 0
        },
        
      ]
    },
        {
      title: "Advert",
      link: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 80,
          subIndex: 0
        }
      ]
    },
    {
      title: "Obituaies",
      link: "Mark Rance (NZL) / Daniel R. DeChaine Jr. (USA) ",
      cssClass: "grey",
      hideInMenu: false,
      pageLinks: [
        {
          index: 81,
          subIndex: 0
        },
        
      ]
    },
  ],
  "mobileTemplate": null,
}



// WEBPACK FOOTER //
// ./src/document.js